<template>
<div class="flex column fill relative">

    <div class="" v-if="!hideSaleType">

        <div class="flex mb15 input-group" v-if="!hideSaleTypeButtons">
            <button v-if="settings.accept_serve" @click="ChangeSale('SERVE')" class="flex-fill w33 secondary" :style="{'background-color': sale=='SERVE'?(table?'var(--color-table)':'var(--color-serve)'):'', color: sale=='SERVE'?'white':''}">{{table?'Mesa':'Servir'}}</button>
            <button v-if="settings.accept_takeaway" @click="ChangeSale('TAKEAWAY')" class="flex-fill w33 secondary" :style="{'background-color': sale=='TAKEAWAY'?(takeaway || wasShipment ? 'var(--color-takeaway-time)' : 'var(--color-takeaway)'):'', color: sale=='TAKEAWAY'?'white':''}">{{takeaway?'Retirar':'LLevar'}}</button>
            <button v-if="settings.accept_delivery" @click="ChangeSale('DELIVERY')" class="flex-fill w33 secondary" :style="{'background-color': sale=='DELIVERY'?(wasShipment?'var(--color-shipment-transit)':'var(--color-delivery-transit)'):'', color: sale=='DELIVERY'?'white':''}">{{wasShipment ? 'Encargo' : 'Delivery'}}</button>
        </div>

        <input-field :inputClass="Util.StringToTime(serveTime) ? 'input-top' : ''"
        v-if="sale == 'SERVE' && !schedule && !table"
        v-model="serveTime"
        placeholder="Hora Servir (Opcional)"
        pre="chronometer"
        info="Indica la hora en que se pasará a retirar el pedido, ejemplo:<br><ul><li>11:30, 11.30, 11 30 (en formato 24 horas por lo que equivale a las 11:30 AM)</li><li>5pm, 17, 5 30 pm</li><li>40 min, 40m, 1 hora, 1h (el pedido será retirado en 40 minutos o 1 hora)</li><li>1 hora 20 min, 1h 20m, 1 hora 20, 1h 20, en 1 20 (el pedido será retirado en 1 hora 20 minutos)</li></ul>">
            <!--
            <div class="append" slot="after">
                
                <i slot="after" class="c4 icon icon-question selectable" @click="Info(``)"></i>
                <i slot="after" class="ml5 c4 icon icon-datetime selectable" @click="$refs.dateSchedule.Open()" title="Agendar pedido"></i>
                
            </div>-->
            <button @click="schedule = Util.Timestamp()" class="secondary border bl0" slot="after">Agendar</button>
        </input-field>
        <div v-show="sale == 'SERVE' && !schedule" class="secondary-text well mini border bottom" v-if="Util.StringToTime(serveTime)">El pedido se retirará a las {{Util.StringToTime(serveTime)}} hrs</div>
        <input-select 
        v-if="sale =='SERVE' && Local.modules.module_tables && !serveTime && !schedule"
        v-show="tables.length > 1"
        v-model="table"
        :items="tables"
        canType="search"
        class="mt10"
        pre="table"
        cleareable>
        </input-select>

        <input-field :inputClass="Util.StringToTime(takeaway) ? 'input-top' : ''"
        v-if="sale == 'TAKEAWAY' && !schedule"
        v-model="takeaway"
        placeholder="Hora Retiro (Opcional)"
        pre="chronometer"
        info="Indica la hora en que se pasará a retirar el pedido, ejemplo:<br><ul><li>11:30, 11.30, 11 30 (en formato 24 horas por lo que equivale a las 11:30 AM)</li><li>5pm, 17, 5 30 pm</li><li>40 min, 40m, 1 hora, 1h (el pedido será retirado en 40 minutos o 1 hora)</li><li>1 hora 20 min, 1h 20m, 1 hora 20, 1h 20, en 1 20 (el pedido será retirado en 1 hora 20 minutos)</li></ul>">
            <!--
            <div class="append" slot="after">
                
                <i slot="after" class="c4 icon icon-question selectable" @click="Info(``)"></i>
                <i slot="after" class="ml5 c4 icon icon-datetime selectable" @click="$refs.dateSchedule.Open()" title="Agendar pedido"></i>
                
            </div>-->
            <button @click="schedule = Util.Timestamp()" class="secondary border bl0" slot="after">Agendar</button>
        </input-field>
        <div v-show="sale == 'TAKEAWAY' && !schedule" class="secondary-text well mini border bottom" v-if="Util.StringToTime(takeaway)">El pedido se retirará a las {{Util.StringToTime(takeaway)}} hrs</div>

        <input-field :inputClass="Util.StringToTime(deliveryTime) ? 'input-top' : ''"
        v-if="sale == 'DELIVERY' && !schedule && !pedidosYa"
        v-model="deliveryTime"
        placeholder="Hora Entrega (Opcional)"
        pre="chronometer"
        info="Indica la hora en que se entregará el pedido, ejemplo:<br><ul><li>11:30, 11.30, 11 30 (en formato 24 horas por lo que equivale a las 11:30 AM)</li><li>5pm, 17, 5 30 pm</li><li>40 min, 40m, 1 hora, 1h (el pedido será retirado en 40 minutos o 1 hora)</li><li>1 hora 20 min, 1h 20m, 1 hora 20, 1h 20, en 1 20 (el pedido será retirado en 1 hora 20 minutos)</li></ul>">
            <button @click="schedule = Util.Timestamp()" class="secondary border bl0" slot="after">Agendar</button>
            <button slot="after" v-if="Local.modules.module_pya_courier && settings.pya && !hideActions" v-tooltip="'Enviar por PedidosYa'" class="secondary border bl0 btn-pya" @click="openModalPya()"><i class="icon icon-pedidosya"></i></button>
        </input-field>
        <div v-show="sale == 'DELIVERY' && !schedule" class="secondary-text well mini border bottom" v-if="Util.StringToTime(deliveryTime)">El pedido se entregará a las {{Util.StringToTime(deliveryTime)}} hrs</div>

        <input-date
        :class="sale == 'SERVE' ? 'mt10' : ''"
        ref="dateSchedule"
        v-if="schedule && !pedidosYa && !table"
        v-model="schedule"
        :type="wasShipment ? wasShipment : 'DATETIME'"
        format="timestamp"
        :minutesStep="5"
        minDate="today">
            <div v-if="!wasShipment" class="append" slot="after">
                <i  class="icon icon-cross selectable c4" title="Quitar fecha" @click.stop="schedule=null"></i>
            </div>
        </input-date>

        <div class="mt10 flex column" v-if="sale == 'DELIVERY' && pedidosYa">
            <div class="well mini input-top flex align-center" style="color: var(--white); background-color: var(--color-pya)">
                <i class="icon icon-pedidosya mr5"></i>
                <span class="flex-fill">Envio por PedidosYa</span>
                <i  class="icon icon-cross selectable" v-tooltip="'Eliminar envio de PedidosYa'" @click.stop="pedidosYa=null; deliveryCost=null;$delete(customer, 'email')"></i>
            </div>
            <div class="well mini input-bottom border">
                
                <span v-if="schedule"><i class="icon icon-calendar" style="margin-right: 6px"></i> {{Util.Date(schedule, 'HH:mm DD/MM/YYYY')}}</span>
                <span v-else><i class="icon icon-chronometer" style="margin-right: 6px"></i> Inmediato <span v-if="pedidosYa.time_offset" class="secondary-text">({{Util.SecondsToTime(pedidosYa.time_offset * 60)}})</span></span>
            </div>


		</div>

        <input-select v-model="customer.name"
        placeholder="Nombre (Opcional)"
        coverInput class="mt10"
        canType
        pre="user"
        :cleareable="true"
        :readonly="isInputReadonlyName"
        @OnItemSelected="SelectCustomer($event)"
        @OnClearItem="ClearFields('name')"
        :api="{
            url: `/customers/${this.Local.id}/results/name/{SEARCH}`,
            text: 'name',
            description: 'phone'
        }">
        </input-select>
            
        <input-select canType v-model="customer.phone"
        placeholder="Teléfono (Opcional)"
        coverInput class="mt10"
        pre="phone"
        :cleareable="true"
        :readonly="isInputReadonlyName"
        @OnItemSelected="SelectCustomer($event)"
        @OnClearItem="ClearFields('phone')"
        :api="{
            url: `/customers/${this.Local.id}/results/phone/{SEARCH}`,
            text: 'phone',
            description: 'name'
        }">            
        
            <button v-if="customer.phone && !isInputReadonlyName" v-tooltip="'Editar teléfono'" @click.stop="modalEditPhone = true" class="secondary border bl0" slot="after"><i class="icon icon-edit"></i></button>
            <button v-if="customer.phone && showLastOrders" v-tooltip="'Pedidos anteriores'" @click.stop="$emit('OnCustomerLastOrders', customer.phone)" class="secondary border bl0" slot="after"><i class="icon icon-history"></i></button>
        </input-select>

        <input-select v-model="customer.rut"
        v-if="settings && settings.enabled_rut_field_orders"
        placeholder="RUT (Opcional)"
        coverInput 
        class="mt10"
        canType
        pre="staff"
        :cleareable="true"
        :readonly="isInputReadonlyName"
        @OnItemSelected="SelectCustomer($event)"
        @OnClearItem="ClearFields('rut')"
        :api="{
            url: `/customers/${this.Local.id}/results/rut/{SEARCH}`,
            text: 'rut',
            description: 'name',
        }">
        </input-select>
        
        <input-field class="mt10" v-if="pedidosYa && sale == 'DELIVERY'"
        v-model="customer.email"
        pre="mail"
        placeholder="Email (Opcional)">
        </input-field>

        <div class="mt10" v-if="sale=='DELIVERY'">

            <!--
            <input-field class="input-top"
            v-model="customer.address"
            pre="google-maps"
            placeholder="Dirección (Opcional)"
            :readonly="pedidosYa? true : false">
            </input-field>
            -->
            
            <input-select canType v-model="customer.address"
            placeholder="Dirección (Opcional)"
            coverInput class="mt10 input-top"
            cleareable
            :readonly="pedidosYa? true : false"
            pre="google-maps"
            @OnItemSelected="SelectSearchAddress($event)"
            @OnEnterItem="$delete(customer, 'latitude'); $delete(customer, 'longitude'); $delete(customer, 'maps_address')"
            @OnClearItem="$delete(customer, 'latitude'); $delete(customer, 'longitude'); $delete(customer, 'maps_address')"
            :api="{
                url: `/address/${this.Local.id}/search/{SEARCH}?costs=true`,
                text: 'title',
                description: 'delivery_cost',
                timer: 2000
            }">
            </input-select>
            
            <input-field class="input-middle"
            v-model="customer.address_additional"
            pre="comment"
            placeholder="Comentario (Opcional)">
            </input-field>

            <input-field class="input-middle" v-if="pedidosYa"
            v-model="pedidosYa.address_additional"
            pre="comment"
            placeholder="Comentario de Dirección (Opcional)">
            </input-field>
            <input-field class="input-middle" v-if="pedidosYa"
            v-model="pedidosYa.instructions"
            pre="comment"
            placeholder="Instrucciones de Reparto (Opcional)">
            </input-field>

            <input-select v-if="canEditDeliveryCost && !pedidosYa" :class="activeRule ? 'input-middle' : 'input-bottom'"
            v-model="deliveryCost"
            :items="settings.delivery_costs"
            :placeholder="settings.delivery_cost_require ? 'Costo de Reparto (Obligatorio)' : 'Costo de Reparto (Opcional)'"
            :canType="settings.delivery_cost_require ? false : true"
            ref="selectDeliveryCost"
            pre="delivery"
            coverInput
            :customValueFunction="settings.delivery_cost_require ? null : Util.InputSelectCustomValuePrice">
            </input-select>
            <input-field class="input-bottom"
                v-if="!pedidosYa && activeRule"
                :readonly="true"
                :value="`${activeRule.text}`"
                pre="delivery"
                :info="`<ul><li>Los repartos tendrán costo ${Util.Price(activeRule.cost)} si el total del pedido es mayor o igual a ${Util.Price(activeRule.condition)}</li></ul>`">
            </input-field>
            <div class="well mini input-bottom border" v-if="pedidosYa">
                <i class="icon icon-delivery" style="margin-right: 6px"></i>
                <span>{{Util.Price(deliveryCost)}}</span>
                <span v-if="pedidosYa.discount" class="secondary-text ml10">-{{Util.Price(pedidosYa.discount)}} DCTO</span>
            </div>
        </div>

        <div class="separator mt20 mb20"></div>

    </div>


    <div class="">

        <div v-if="!hideItems || !hideComment" class="f18 mb10 flex align-center">
            <div class="flex-fill">Pedido</div>
            <i v-if="editItemPricePOS && canEditItemPricePOS && orderedItems.length" class="options icon-edit-price ml5" v-tooltip="'Editar precio unitario de productos'" @click="OpenModalChangePriceItem()"></i>
        </div>

        <div :class="`well relative mb10 ${canEditItems && ((item.key && item.key.indexOf('order-') == -1) || canEditOld) ? 'selectable' : ''}`"
        v-show="!hideItems"
        v-for="(item, itemIndex) in orderedItems" 
        :key="`${item.key}-${itemIndex}`"
        @click="canEditItems && ((item.key && item.key.indexOf('order-') == -1) || canEditOld) ? SetItem(item, item.key, item.quantity-1) : null"
        v-longclick="() => {canEditItems  && ((item.key && item.key.indexOf('order-') == -1) || canEditOld) ? EditItem(item, item.key) : null}">
            <div class="order-item">
                <div>{{Util.Number(item.quantity)}}</div>
                <div>
                    <div>{{item.title}} <i v-if="item.paid_at" class="icon-bill cgreen"></i></div>
                    <ul>
                        <li :class="modifier.type" v-for="(modifier, indexMod) in Util.ModifiersList(item,dictDiners ? Util.CustomerHasPhone(dictDiners[item.diner], true) : null)" :key="indexMod">
                            <span v-html="modifier.htmlValue"></span>
                            <span class="tag-total-modifiers" v-if="modifier.count > 1">{{modifier.count}}</span>
                        </li>
                    </ul>
                </div>
                <div>{{Util.Price(item.total_money)}}</div>
                <div v-if="item.tag" :class="`absolute tag-order-form tag-${item.tag}`"></div>
            </div>
        </div>

        <input-field v-if="!hideComment"
        v-model="comment"
        inputClass="secondary"
        placeholder="(Comentario opcional)"
        :lines="3">
        </input-field>

        <div v-if="!hideItems || !hideComment" class="separator mt20 mb20"></div>

        <div class="f18 mb10 flex align-center">
            <div class="flex-fill">Total</div>
            <i v-if="!hideDiscount && (canAddDiscount || canAddCoupon)" class="options icon-discount" v-tooltip="'Agregar cupón o descuento'" @click="OpenModalDiscount()"></i>
            <i v-if="canEditTips && !hideAddTip" class="options icon-coins" v-tooltip="'Agregar propina'" @click="OpenTip()"></i>
        </div>
        
        <div class="flex align-center" v-if="totalAlreadyPaid > 0">
            <div class="flex-fill">Pagado</div>
            <div>{{Util.Price(totalAlreadyPaid)}}</div>
        </div>

        <div class="flex align-center">
            <div class="flex-fill">Subtotal</div>
            <div>{{Util.Price(total.order)}}</div>
        </div>

        <div class="flex" v-if="sale == 'DELIVERY'">
            <div class="flex-fill">Costo Reparto <i v-if="pedidosYa" class="icon icon-pedidosya" style="color: var(--color-pya)"></i></div>
            <div>{{Util.Price(activeRule ? activeRule.cost : (deliveryCost ? deliveryCost : 0))}}</div>
        </div>
        
        <!--
        <div class="selectable" v-show="discounts.totalDiscount > 0"
        @click="showDiscountDetails = !showDiscountDetails">
            <div class="flex column fill">
                <div class="fill flex align-center">
                    <div class="flex-fill"><i :class="`icon icon-${showDiscountDetails ? 'invisible' : 'eye'} mr5`"></i>Descuento</div>
                    <div>-{{Util.Price(discounts.totalDiscount)}}</div>
                </div>
                <div class="secondary-text" v-if="showDiscountDetails">
                    <div v-for="(discount, index) in discounts.arrDiscounts"
                    :key="index">{{discount.title}} ({{Util.Price(discount.discount)}})
                    </div>
                </div>
            </div>
        </div>
        -->
        <div class="selectable " v-if="discounts.totalDiscount"
        @click="showDiscountDetails = !showDiscountDetails">
            <div class="flex column fill">
                <div class="fill flex align-center">
                    <div class="flex-fill"><i :class="`icon icon-${showDiscountDetails ? 'invisible' : 'eye'} mr5`"></i>Descuento</div>
                    <div>- {{Util.Price(discounts.totalDiscount)}}</div>
                </div>
                <div class="secondary-text" v-if="showDiscountDetails">
                    <div v-for="(discount, index) in discounts.arrDiscounts"
                    :key="index">{{discount.title}} ({{Util.Price(discount.discount)}})
                    </div>
                </div>
            </div>
        </div>
        <div :class="`well mt5 mb5 selectable ${discounts.codeUsed ? 'selected cpurple' : ''}`" v-if="coupon" @click="modalCouponDetails=coupon">
            <div class="flex column fill">
                <div class="flex fill">
                    <div class="flex column flex-fill">
                        <div class="bold">{{Util.CouponDiscountType(coupon)}}</div>
                        <div class="secondary-text"><span class="bold">Código: </span>{{coupon.code}}</div>
                    </div>
                    <div>
                        <i class="options icon-cross" v-tooltip="'Quitar cupón'" @click.stop="Confirm({
                            title: `¿Quitar cupón?`,
                            text: 'Quitar',
                            class: 'error-color',
                            function: () => {UpdateDiscounts(coupon, 'delete');}
                        })"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="well mt5 mb5 selected cpurple"
        v-if="customDiscount">
            <div class="flex column fill">
                <div class="flex fill">
                    <div class="flex column flex-fill">
                        <div class="bold">Dcto ingresado en caja</div>
                        <div class="secondary-text">
                        <span class="bold">Valor: </span>{{ Util.IsPrice(customDiscount) }}
                        </div>
                    </div>
                    <div>
                        <i class="options icon-cross"
                        v-tooltip="'Quitar descuento'"
                        @click.stop="Confirm({
                            title: '¿Quitar descuento?',
                            text: 'Quitar',
                            class: 'error-color',
                            function: () => { UpdateDiscounts(customDiscount, 'delete'); modalDiscount=null; }
                        })" />
                    </div>
                </div>
            </div>
        </div>

        <div class="flex" v-if="roundTotal">
            <div class="flex-fill">Ley Redondeo</div>
            <div>${{roundTotal}}</div>
        </div>

        <div class="w100 flex" v-for="(tipEntry, index) in tips" :key="`tip${index}`">
            <div class="flex column flex-fill">
                <div><i v-if="canEditTips" @click="tips.splice(index, 1);tipEntry.type=='DEFAULT'? hasDeletedDefaultTip=true:null" class="icon icon-cross selectable mr5"></i>Propina<span v-if="tipEntry.type == 'DEFAULT'">* </span> 
                    <span class="secondary-text" v-if="tipEntry.amount == 'CASH'"> (Resto efectivo)</span>
                    <span class="secondary-text" v-else-if="tipEntry.amount && tipEntry.amount.indexOf('%') > -1"> ({{ tipEntry.amount }})</span>
                    <span class="secondary-text" v-else-if="tipEntry.amount && tipEntry.amount.indexOf('-') > -1"> (Resto {{ Util.Price(tipEntry.amount.replace('-', '')) }})</span>
                </div>
                <div class="secondary-text"><span class="secondary-text" v-if="tipEntry.index !== null">Método {{tipEntry.index+1}} - </span>{{Util.PayMethod(tipEntry.method)}}</div>
            </div>
            <div>{{Util.Price(tipEntry.total)}}</div>
        </div>

        <div class="f18">
            <div :class="`fill flex align-center ${fromTransaction && fromTransaction.paid_at ? 'cgreen' : ''}`">
                <div class="bold flex-fill">Total</div>
                <div class="bold">{{Util.Price(totalMoney)}}</div>
            </div>
        </div>
        
        <div class="f18" v-if="totalTips">
            <div class="fill flex align-center">
                <div class="bold flex-fill">Total con propina</div>
                <div class="bold">{{Util.Price(totalTips + totalMoney)}}</div>
            </div>
        </div>
    </div>

    <div class="flex column" v-if="paymentMethods.length > 0" v-show="!(sale == 'SERVE' &&  table) && !hidePayments">

        <div class="separator mb20 mt20"></div>

        <div class="f18 mb10 flex align-center">
            <div class="flex-fill">Método de Pago</div>
            <i class="options icon-receipt-divided selectable border-trace" v-tooltip="'Cargar la división de pago'" v-if="pendingPaymentMethodsData" @click="ApplyInvoiceHelperMethods()">
                <svg class="trace" viewBox="-5 -5 105 105" preserveAspectRatio="none"><rect x="-2.5" y="-2.5" width="100" height="100" rx="22" ry="22" pathLength="100"/></svg>
            </i>
            <i class="options icon-calculator" v-tooltip="'Dividir pago'" v-if="canEditPayment && !hasDinerSelected" @click="OpenDividePayment()"></i>
            <i class="options icon-plus" v-if="canEditPayment && (!paymentMethods.length || !paymentMethods[0].method.startsWith('ONLINE')) && !hasDinerSelected" @click="paymentMethods.push({method: availablePaymentMethods[0].value, subtotal: null, showBtnNTransfer : false})" v-tooltip="'Agregar método de pago'"></i>
        </div>
        <div v-for="(method, index) in paymentMethods" :key="index">
            <div class="mb20" v-if="Object.keys(method).length > 0">
                <div class="well mini border top flex align-center secondary-text" v-if="(method.paid_at || paymentMethods.length > 1)">
                    <div class="flex-fill unshrink">{{ method.diner && method.diner != 'ALL' ? Util.CustomerHasPhone(dictDiners[method.diner], true) : `Método ${index+1}` }}<i v-if="(paymentMethods.length > 1 && paymentMethods[index].subtotal > 0)" :class="`icon-bill selectable ml5 ${method.paid_at ? 'cgreen' : ''}`" @click="!method.paid_at ? RegisterPartialPayment(index) : DeletePartialPayment(index)" :title="!method.paid_at ? 'Marcar como pagado' : 'Desmarcar pagado'"></i></div>
                    <div v-if="method.paid_at">
                        <div class="flex-fill">Parte pagada {{Util.Date(method.paid_at, 'HH:mm')}}</div>
                    </div>
                    <i v-if="canEditPayment && paymentMethods.length > 1" @click="DeleteOrderPayment(index)" class="icon-cross selectable ml10"></i>
                </div>

                <input-field 
                v-show="paymentMethods.length > 1" 
                :inputClass="(paymentMethods.length > 1 || method.paid_at ? 'input-middle' : (method.method == 'CASH' ? 'input-top' : ''))"
                v-model="method.subtotal"
                @OnChange="CalculateSubtotals(index)"
                :placeholder="`(Subtotal a pagar con ${Util.PayMethod(method.method)})`"
                :readonly="!canEditPayment"
                type="number">
                    <div slot="after" class="append unshrink" v-if="method.round != null && method.round !== 0"  v-tooltip="`Ley del Redondeo`">
                        <div class="secondary cred">${{ method.round > 0 ? '+' : '' }}{{ method.round }}</div>
                    </div>
                    <div slot="after" class="append unshrink" v-if="MethodTip(index) !== false">
                        <span class="bold mr5">con propina </span>{{Util.Price(MethodTip(index) + method.subtotal + (method.method === 'CASH' && method.round != null ? method.round : 0))}}
                        <i
                            class="icon icon-cross selectable ml5"
                            v-tooltip="'Quitar propina de este método'"
                            @click.stop="tips = (tips || []).filter(t => t && t.index !== index)"
                        ></i>
                    </div>
                    
                    <div slot="after" class="append unshrink pa0 bl0" v-else-if="method.method !== 'NO_SELECT' && !method.paid_at">
                        <button class="secondary" v-tooltip="'Agregar Propina'" style="border-radius: 0px;" @click="modalTips={subtotal: {total: method.subtotal, method: method.method, index: index, target: 'METHOD'}, subtotals: [], amount: '10%', method: method.method, methods: []}"><i class="icon icon-coins"></i></button>
                    </div>
                    
                </input-field>

                <input-select  class="flex-fill" :inputClass="paymentMethods.length > 1 || method.paid_at ? (method.method == 'CASH' || method.showBtnNTransfer ? 'input-middle' : 'input-bottom') : (method.method == 'CASH' || method.showBtnNTransfer ? 'input-top' : '')"
                v-model="method.method"
                :items="paymentMethodSelectItems"
                :readonly="!canEditPayment"
                canType="search"
                @OnValueChanged="OnPaymentMethodChanged($event, index)">
                    <!--TODO: hacer una clase para ese style ? y algo para el input-select y no tener que ocupar click.stop -->
                    <button slot="after" v-if="method.method != 'CASH' && method.method != 'NO_SELECT'" v-tooltip="'N° pago/transferencia'" class="secondary border bl0"   :class="method.showBtnNTransfer ? 'input-top' : null" 
                    :style= "method.showBtnNTransfer ? (paymentMethods.length > 1 ? 'border-bottom-right-radius: 0px !important; border-top-right-radius: 0px !important;' : 'border-bottom-right-radius: 0px !important;')  : (paymentMethods.length > 1 ? 'border-top-right-radius: 0px !important;' : null)"  
                    @click.stop="ToggleBtnNTransfer(index)"><i class="icon icon-sheet"></i></button>
                </input-select>

                <input-field v-if="method.method == 'CASH'" inputClass="input-bottom"
                v-model="method.cash"
                prefix="Efectivo: $"
                placeholder="Efectivo (Opcional)"
                :readonly="!canEditPayment"
                @OnChange="RecalculateTip(index)"
                type="int+">
                    <div slot="after" class="append primary" v-if="MethodChange(method, index) !== false">
                        <span class="bold mr5">Vuelto</span>{{Util.Price(MethodChange(method, index))}}
                        <div v-if="paymentMethods.length > 1 && !MethodTip(index) || !tips.length">
                            <div style="width: 20px;"></div>
                            <!--<button class="secondary absolute" v-tooltip="'Agregar Vuelto como Propina'" style="right: 1px; height: 35px; background-color: transparent !important; top: 2px; padding-right: 10px" @click="modalTips={subtotal: {total: paymentMethods.length > 1 ? method.subtotal : totalMoney, method: 'CASH', index: paymentMethods.length > 1 ? index : null, target: paymentMethods.length > 1 ? 'TOTAL' : 'METHOD'}, subtotals: [], amount: -method.cash, method: method.method, methods: []}"><i class="icon icon-coins"></i></button>-->
                            <button class="secondary absolute" v-tooltip="'Agregar Vuelto como Propina'" style="right: 1px; height: 35px; background-color: transparent !important; top: 2px; padding-right: 10px" @click="tips.push({method: 'CASH', total: 0, amount: 'CASH', index: index, target: 'METHOD'}); RecalculateTip(tips[tips.length-1])"><i class="icon icon-coins"></i></button>
                        </div>
                    </div>
                    <!-- <div slot="after" class="flex" v-if="!isNaN(method.cash) && method.cash-method.subtotal > 0"><span class="bold mr5">Vuelto </span>{{Util.Price(method.cash - method.subtotal)}}</div> -->
                </input-field>

                <input-field v-if="method.method != 'CASH' && method.showBtnNTransfer && method.method != 'NO_SELECT'" inputClass="input-bottom"
                v-model="method.n_transfer"            
                :ref="'nTransfer_' + index"
                placeholder="N° pago/transferencia (Opcional)"
                before=" "
                pre=" ">
                <span class="icon" slot="inner-before">
                    N°
                </span>
                </input-field>
            </div>
        </div>

        <div v-if="availableDeliveryPaymentMethods" class="mb20">
            <div class="well mini secondary-text border input-top"><i class="icon icon-delivery mr5"></i> Método de Pago Reparto ({{Util.Price(deliveryCost)}})</div>
            <input-select inputClass="input-bottom"
            v-model="deliveryPaymentMethod"
            :items="availableDeliveryPaymentMethods"
            canType="search"
            :readonly="!canEditPayment || (this.Auth.role.indexOf('admin') == -1 && !!Auth.restrictions.lock_delivery_payment_method)">
            </input-select>
        </div>
        
    </div>

    <div class="flex-fill"></div>
    
    <div class="bottom-actions" :style="mobile ? {bottom: '10px'} : null">
        <button v-show="hasScroll && !isScrollAtBottom" @click="Util.ScrollToBottom(parentScrollEl)" class="absolute primary blue mr5" style="z-index: 100; left: 0px; top: -50px; border-radius: 50%; width: 40px; height: 40px" v-tooltip="'Bajar'"><i class="icon icon-arrow-down"></i></button>
        <button v-if="!hideActions" :disabled="total.items <= 0 || (settings.no_payment_select && paymentMethods.some(method => method.method == 'NO_SELECT') && !table) || sale === null || (settings.delivery_cost_require && sale === 'DELIVERY' && deliveryCost === null )" :class="`w100 primary purple`" @click="RegisterOrder()" style="">{{schedule && schedule > Util.Date('now', 'timestamp') ? 'Agendar Pedido' : 'Ingresar Pedido'}}<span v-if="total.items > 0" class="ml5">{{Util.Price(total.totalMoney - discounts.totalDiscount + roundTotal)}}</span></button>
        <!-- <button v-if="!hideActions" :disabled="total.items <= 0 || (settings.no_payment_select && paymentMethods.some(method => method.method == 'NO_SELECT') && !table) || sale === null || (settings.delivery_cost_require && sale === 'DELIVERY' && deliveryCost === null )" :class="`w100 primary purple`" @click="RegisterOrder()" style="">Ingresar Pedido<span v-if="total.items > 0" class="ml5">{{Util.Price(total.totalMoney - discounts.totalDiscount + roundTotal)}}</span></button> -->
        <slot name="actions"></slot>
    </div>

    <!-- MODALS VVVV -->

    <modal v-model="modalItemQuantity" dir="up" maxSize="80vh">
        <div class="pa10 flex" v-if="modalItemQuantity">
            <i @click="modalItemQuantity.quantity--" class="options icon-minus"></i>
            <input-field class="flex-fill ml10 mr10"
            v-model="modalItemQuantity.quantity"
            type="number"
            label="Cantidad">
            </input-field>
            <i @click="modalItemQuantity.quantity++" class="options icon-plus"></i>
        </div>
        <div class="modal-actions" v-if="modalItemQuantity">
            <button :class="`${modalItemQuantity.quantity <= 0 ? 'error-color' : 'selected-color'} outline`" 
            @click="SetItem(modalItemQuantity.item, modalItemQuantity.key, modalItemQuantity.quantity);modalItemQuantity=null">Aceptar</button>
        </div>
    </modal>

    <!-- <modal v-model="modalDiscount" dir="center" modalClass="sm" :title="`${canAddCoupon && canAddDiscount ? 'Cupón / Descuento' : (canAddCoupon ? 'Cupón' : 'Descuento')}`">
        <div class="section" v-if="modalDiscount">
            <input-field
            v-model="modalDiscount.amount"
            :label="`${canAddCoupon && canAddDiscount ? 'Cupón / Descuento' : (canAddCoupon ? 'Cupón' : 'Descuento')}`"
            :description="`${canAddCoupon && canAddDiscount ? 'Ingresa el código de un cupón o el monto de descuento, puede ser un número fijo o un porcetaje' : (canAddCoupon ? 'Ingresa el código de un cupón' : 'Ingresa el monto de descuento, puede ser un número fijo o un porcetaje')}`"
            :placeholder="`${canAddCoupon && canAddDiscount ? '(Ejemplo: 20%)' : (canAddCoupon ? '' : '(Ejemplo: 20%)')}`">
            </input-field>
        </div>
        
        <button slot="actions" v-if="customDiscount" class="primary error-color" @click="customDiscount=null; modalDiscount=null">Eliminar</button>
        <button slot="actions" v-if="canAddDiscount" class="primary purple" @click="SetCustomDiscount()">Ingresar <span v-if="canAddCoupon && modalDiscount && modalDiscount.amount.length >= 5 && !isNaN(modalDiscount.amount)" class="ml5">DCTO</span></button>
        
        <button v-if="(canAddCoupon && !canAddDiscount) || (canAddCoupon && modalDiscount && modalDiscount.amount.length >= 5 && !isNaN(modalDiscount.amount))" slot="actions" class="primary purple" @click="SetCustomDiscount(null, true)">Ingresar Cupón</button>
        
    </modal> -->

    <modal v-model="modalDivide" dir="right" :modalClass="['fill', 'md right h100']" title="Dividir Pago">
        <div class="section" v-if="modalDivide">
            <div class="flex mb15">
                <input-select 
                v-model="modalDivide.divisionOptionSelected"
                inputClass="secondary"
                style="width: 100%;"
                :items="modalDivide.divisionOptions">
                </input-select>

                <i v-if="modalDivide && modalDivide.divisionOptionSelected === 'PRODUCT'" @click="SelectAllCustomersForAllItems()" title="Seleccionar todos los comensales" class="options ml5" :class="{'icon-cross': IsAllCustomersSelected(),'icon-check': !IsAllCustomersSelected()}"></i>
            </div>
            <div class="entry" v-if="modalDivide && modalDivide.divisionOptionSelected === 'PRODUCT'"
            v-for="(item, index) in modalDivide.items" :key="index">
                <div class="fill hdvm">
                      <div class="flex column flex-fill justify-center">
                        <div></div>
                        <div>{{item.title}}</div>
                        <ul class="secondary-text"><li :class="modifier.type" v-for="(modifier, indexMod) in Util.ModifiersList(item)" :key="indexMod">{{modifier.value}}</li></ul>
                    </div>
                    <div class="flex align-center" style="width: auto !important">
                        <div :class="`customer-divide ${item['customer-'+i] ? 'selected' : ''}`"
                        @click="$set(item, 'customer-'+i, item['customer-'+i] ? false : true)"
                        v-for="i in modalDivide.customers" :key="`item-${index}-customer-${i}`">{{i}}</div>
                        <i @click="SelectAllCustomers(item)" title="Seleccionar todos" class="options ml5" :class="{'icon-cross': IsAllCustomersSelected(item),'icon-check': !IsAllCustomersSelected(item)}"></i>
                    </div>
                </div>
            </div>
            <div v-if="modalDivide && modalDivide.divisionOptionSelected === 'TOTAL'" class="well flex bold" style="justify-content: space-between;">
                <div>Total a dividir</div>
                <div>{{Util.Price(totalMoney)}}</div>
            </div>
            <div v-if="modalDivide && modalDivide.divisionOptionSelected === 'NOTPAY'" class="well flex bold" style="justify-content: space-between;">
                <div>Total pedidos no pagados</div>
                <div>{{Util.Price(modalDivide.unpaidTotal)}}</div>
            </div>
            <div v-if="modalDivide && modalDivide.divisionOptionSelected && modalDivide.divisionOptionSelected.startsWith('BYMETHOD_')" >
                <div class="well flex mb15 bold" style="justify-content: space-between;">
                    <div>Método</div>
                    <div>{{Util.PayMethod(selectedPaymentMethod.method)}}</div>
                </div>
                <div class="well flex bold" style="justify-content: space-between;">
                    <div>Subtotal</div>
                    <div>{{ Util.Price(selectedPaymentMethod.subtotal) }}</div>
                </div>
            </div>
        </div>
        
        <div slot="actions" class="flex algin-center flex-fill mr20" v-if="modalDivide">
        
            <i class="options icon-minus mr5" @click="modalDivide.customers > 2 ? $set(modalDivide, 'customers', modalDivide.customers-1) : null"></i>
            <input-field class="flex-fill"
            v-model="modalDivide.customers"
            type="int+"
            suffix=" clientes">
            </input-field>
            <i class="options icon-plus ml5" @click="$set(modalDivide, 'customers', modalDivide.customers+1)"></i>
            
        </div>
        <button slot="actions" class="primary purple" @click="DividePayment()">Dividir</button>
        
    </modal>

    <modal v-model="modalTips" :dir="['right', 'center']" :modalClass="['fill', 'sm']" title="Agregar Propina">
        <div class="section" v-if="modalTips">
            <input-select class="mb15" v-if="modalTips.subtotals.length"
            label="Total"
            description="Indica sobre que monto se calculará la propina"
            @OnValueChanged="$set(modalTips, 'method', $event.method)"
            v-model="modalTips.subtotal"
            :items="modalTips.subtotals">
            </input-select>
            <!--
            <div class="input-style">
                <div class="input-label">Total</div>
                <div>{{Util.Price(total.totalMoney - discounts.totalDiscount)}}</div>
            </div>
            -->
            <input-field v-model="modalTips.amount" label="Propina" class="mb15" 
            info="<ul><li>Porcentaje: 10% ó 10x ó 10X equivale al 10% del total</li><li>Resto: -10000 equivale al $10.000 - el total</li><li>Fijo: 2500 equivale a una propina fija de $2.500</li></ul>">
            </input-field>

            <input-select v-model="modalTips.method" v-if="modalTips.methods.length"
            :items="modalTips.methods" 
            label="Método de Pago"
            canType="search">
            </input-select>
        </div>
        
        <button slot="actions" class="primary purple" :disabled="!tip" @click="AddTip()">Agregar Propina <span v-if="tip && modalTips.subtotal.index !== 'EACH_METHOD'" class="ml5">{{Util.Price(tip)}}</span></button>
        
    </modal>

    <modal v-model="modalCouponDetails" title="Detalles del Cupón" dir="center" modalClass="md" hideActions>
        <div class="pa20" v-if="modalCouponDetails">
            <div class="mb20">
                <div class="bold" v-if="modalCouponDetails.discount != 'PER_PRODUCT'">{{Util.CouponDiscountType(modalCouponDetails)}}</div>
                <div v-if="modalCouponDetails.limit"><span class="bold">Limite de descuento: </span>{{Util.Price(modalCouponDetails.limit)}}</div>
                <div v-if="modalCouponDetails.minimun"><span class="bold">Mínimo: </span>{{Util.Price(modalCouponDetails.minimun)}}</div>
                <div v-if="modalCouponDetails.method !== 'ANY'"><span class="bold">Método de pago: </span>{{Util.ShowCouponValues(modalCouponDetails.method, 'METHODS')}}</div>
                <div v-if="modalCouponDetails.sale !== 'ANY'"><span class="bold">Compras: </span>para {{Util.ShowCouponValues(modalCouponDetails.sale, 'SALE_TYPES')}}</div>
                <div v-if="CouponItemsRule(modalCouponDetails)">
                    <div><span class="bold">Aplica: </span>{{CouponItemsRule(modalCouponDetails)}} {{ modalCouponDetails.not_apply_discount ? '(sujeto a restricción horaria)' : null }}</div>
                </div>
            </div>
            <div>
                <div class="bold">Productos del Cupón</div>
                <table class="summary">
                    <tr>
                        <th>Item</th>
                        <th>Modificadores Requeridos</th>
                        <th>Aplica a modificadores</th>
                    </tr>
                    <tr v-for="(val, section) in modalCouponDetails.sections ? modalCouponDetails.sections : {}" :key="section">
                        <td>Productos de la sección {{section}} {{ Util.CouponDiscountType(val) }}</td>
                        <td></td>
                        <td>{{val.include_modifiers ? 'Si' : 'No'}}</td>
                    </tr>
                    <tr v-for="(item, index) in modalCouponDetails.items" :key="index">
                        <td>{{item.title}} {{ Util.CouponDiscountType(item) }}</td>
                        <td>
                            <div v-for="(modifier, modIndex) in item.modifiers" :key="`item-${index}-mod-${modIndex}`">{{modifier.group}} - {{modifier.title}}</div>
                        </td>
                        <td>{{item.include_modifiers ? 'Si' : 'No'}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </modal>

    <modal v-model="modalEditPhone" title="Editar teléfono cliente" :dir="['right', 'center']" :modalClass="['fill', 'sm']" >
        <div class="pa20" v-if="modalEditPhone">
            <div class="flex-fill mb15">
                <div class="bold">Nombre</div>
                <div>{{customer.name}}</div>
            </div>
            <div class="flex-fill mb15">
                <div class="bold">Teléfono Actual</div>
                <div>{{customer.phone}}</div>
            </div>
            <input-field 
            class=""
            v-model="customer.newPhone"
            label="Nuevo teléfono"
            >
            </input-field>
            
        </div>
        <button slot="actions" @click="EditCustomerPhone()" class="primary purple">Editar</button>
    </modal>

    <modal v-model="modalChangePriceItem" title="Cambiar Precio Unitario" dir="right" :modalClass="['fill', 'md right h100']"  >
        <div class="pa20" v-if="modalChangePriceItem">
            <div class="well relative mb10 hdvm"
            v-for="(item, itemIndex) in modalChangePriceItem.items" 
            :key="`${item.key}-${itemIndex}`">
                
                    <div class="flex column">
                        <div class="flex"><span style="min-width: 30px; display: inline-block">{{item.quantity}}</span>{{item.title}}</div>
                        <ul style="margin-left: 30px">
                            <li :class="modifier.type" v-for="(modifier, indexMod) in Util.ModifiersList(item)" :key="indexMod">
                                {{modifier.value}}
                            </li>
                        </ul>
                    </div>
                    <div class="flex column">
                        <input-field v-model="item.value_price" @OnChange="$set(item, 'price', item.original_price - Util.ApplyModifier(item.original_price, item.value_price, true))"
                        info="<ul><li>Porcentaje: 10% ó 10x ó 10X equivale al 10% del total</li><li>Resto: -10000 equivale al $10.000 - el total</li><li>Fijo: 2500 equivale a un fijo de $2.500</li></ul>">
                            <i slot="after" class="append selectable icon icon-revert" v-tooltip="'Revertir a precio original'" @click="item.value_price = item.original_price.toString()"></i>
                            <div slot="after" class="append primary bold">{{Util.Price(item.price * item.quantity)}}</div>
                        </input-field>
                        <div class="secondary-text mt5">Precio original {{Util.Price(item.original_price)}}</div>
                    </div>
                </div>
            
        </div>
        <div slot="actions" class="bold f18 align-center mr10">Total {{Util.Price(totalModalChangePriceItem)}} </div>
        <button slot="actions" class="primary purple" @click="ChangePriceTempItem()">Cambiar Precios</button>
    </modal>

    <modal-estimate-pya ref="estimatePya" 
    :pos="true" 
    @CompleteData="FillFields($event)">
    </modal-estimate-pya>

    <modal-coupon-discount 
    ref="modalDiscount"
    :coupon="coupon"
    :isDiner="isDiner"
    @UpdateDiscounts="UpdateDiscounts"
    :selectedBrand="selectedBrand"
    ></modal-coupon-discount>


</div>
</template>
<script>
export default {
    props: {
        value: {
            type: [Object, Array],
            default: () => {}
        },
        fromTransaction: {
            type: [Object, Array],
            default: null
        },
        baseBenefits: {
            type: Array,
            default: () => []
        }, 
        settings: {
            type: Object,
            default: null
        },
        categories: {
            type: [Object, Array],
            default: () => {}
        },
        tables: {
            type: Array,
            default: () => []
        },
        hideSaleType: {
            type: Boolean,
            default: false
        },
        hideCustomer: {
            type: Boolean,
            default: false,
        },
        hideCustomerCreation: {
            type: Boolean,
            default: false
        },
        hideComment: {
            type: Boolean,
            default: false
        },
        hideActions: {
            type: Boolean,
            default: false
        },
        canEditItems: {
            type: Boolean,
            default: true
        },
        hideLastOrder: {
            type: Boolean,
            default: true
        },
        hideSaleTypeButtons: {
            type: Boolean,
            default: false
        },
        canEditPayment: {
            type: Boolean,
            default: true
        },
        canEditDeliveryCost: {
            type: Boolean,
            default: true,
        },
        hideItems: {
            type: Boolean,
            default: false
        },
        hidePayments: {
            type: Boolean,
            default: false
        },
        hideDiscount: {
            type: Boolean,
            default: false
        },
        hideAddTip: {
            type: Boolean,
            default: false
        },
        showLastOrders: {
            type: Boolean,
            default: false
        },
        transbankPOSIntegrado: {
            type: Boolean,
            default: false
        },
        editItemPricePOS: {
            type: Boolean,
            default: false
        },
        setDefaultTip: {
            type: Boolean,
            default: false
        },
        selectedBrand : {
            typee : Object,
            default : null
        },
        mercadopagoPOSIntegrado: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            showDiscountDetails: false,
            modalItemQuantity: null,
            customerAccount: null,

            sale: 'SERVE',
            customer: {},
            comment: null,
            paymentMethods: [],
            customDiscount: null,
            modalDiscount: null,
            table: null,
            modalDivide: null,
            deliveryCost: null,
            takeaway: '',
            //resultados de la bsusqueda de clientes
            customerResults: [],
            //el temporizador para buscar clientes
            timerSearch: null,
            //control para ocultar la lista de busqueda de clientes
            hideSearchBox: true,
            //@data <String> el string de tiempo para tiempo a retirar
            deliveryTime: '',
            coupon: null,
            schedule: null,
            tips: [],
            modalTips: null,
            deliveryPaymentMethod: null,
            isExternalDelivery: false,
            wasShipment: false,
            modalCouponDetails: null,
            pedidosYa: null,
            isInputReadonlyName: false,
            activeRule : null,
            selectRule : null,
            simplifiedData : {},
            modalEditPhone : false,
            dictDiners : null,
            hasDinerSelected : false,
            modalChangePriceItem : null,
            observer: null,
            hasScroll: false,
            parentScrollEl: null,
            isScrollAtBottom: false,
            hasDeletedDefaultTip: false,
            view : null,
            isDiner : null,
            paidDiscounts : [],
            totalAlreadyPaid : 0,
            pendingPaymentMethodsData: null,
            serveTime : '',
        }
    },
    mounted() {
        this.Reset();
        this.SetupScrollListener();
    },
    methods: {
        SetPendingPaymentMethodsData(data) {
            if (data && Array.isArray(data.paymentMethods) && data.paymentMethods.length) {
                this.pendingPaymentMethodsData = data;
            }
        },
        ApplyInvoiceHelperMethods() {
            if (!this.pendingPaymentMethodsData) return;
            let data = this.pendingPaymentMethodsData;
            const methods = Array.isArray(data) ? data : (data && data.paymentMethods);
            if (!methods || !methods.length) return;

            this.paymentMethods = methods.map(value => ({
                method: value.method || 'CASH',
                subtotal: value.subtotal != null ? value.subtotal : null,
                cash: value.cash != null ? value.cash : null,
                round: null,
                showBtnNTransfer: false
            }));

            // Propina [tips]
            this.tips = this.paymentMethods.map((method, index) => {
                const roundValue = (method.method === 'CASH' && method.round != null ? method.round : 0)
                const subtotal = (method.subtotal != null ? method.subtotal : 0) + roundValue;
                
                console.log("SE CALCULA TIPS")
                
                return {
                    index,
                    method: method.method,
                    total: Math.round(subtotal * (10 / 100)),
                    amount: '10%',
                    target: 'METHOD'
                };
            });
            this.pendingPaymentMethodsData = null;
        },
        Reset() {
            this.$emit('input', {});
            this.table = null;
            this.sale = null;
            this.customer = {};
            this.comment = null;
            this.paymentMethods = [];
            this.deliveryCost = null;
            this.hasDeletedDefaultTip = false;
            this.$nextTick(() => {
                var availableSaleTypes = [];
                if(this.settings.accept_serve) availableSaleTypes.push('SERVE');
                if(this.settings.accept_takeaway) availableSaleTypes.push('TAKEAWAY');
                if(this.settings.accept_delivery) availableSaleTypes.push('DELIVERY');
                if(!this.hideSaleType) 
                {
                    this.sale = availableSaleTypes.indexOf(this.settings.default_sale) > -1 ? this.settings.default_sale : (availableSaleTypes.length ? availableSaleTypes[0] : 'SERVE');
                    if(this.settings.default_sale == 'NO_DEFAULT') this.sale = null;
                }
                if(!this.paymentMethods.length) {
                    this.paymentMethods = [{method: this.availablePaymentMethods[0].value, subtotal: null, showBtnNTransfer : false}];
                }else {
                    // Se asegura que el ultimo metodo de pago que tenga el paymentMethods, tenga como metodo seleccionado el metodo predeterminado
                    let lastPaymentMethodIndex = this.paymentMethods.length - 1;
                    if(!this.paymentMethods[lastPaymentMethodIndex].paid_at) this.paymentMethods[lastPaymentMethodIndex].method = this.availablePaymentMethods[0].value;
                }

                if(this.tips.length){
                    this.tips.forEach(tip => {
                        if(!tip.method) tip.method = this.availablePaymentMethods[0].value;                        
                    });
                }
                if(!this.fromTransaction) this.ChangeSale(this.sale);
            });
            this.customerAccount = null;
            this.customDiscount = null;
            this.takeaway = '';
            this.deliveryTime = '';
            this.coupon = null;
            this.schedule = null;
            this.tips = [];
            this.deliveryPaymentMethod = null;
            this.wasShipment = false;
            this.pedidosYa = null;
            this.isInputReadonlyName = false;
            this.totalAlreadyPaid = 0;
            this.pendingPaymentMethodsData = null;
            this.$emit('CleanSearch');
        },
        SetItem(item, key, quantity)
        {
            quantity = this.Util.RoundFloat(quantity);
            if(quantity <= 0)
                this.$delete(this.value, key);
            else
            {
                let price_mod = item.modifiers_price;
                // if(!item.combo && item.original_price != 0) price_mod = 0;
                item = this.Util.ShowWholesalePrice(item, quantity, price_mod, true, true);
                this.$set(item, 'quantity', quantity);
                this.$set(item, 'total_money', parseInt(item.total_money));
            }
        },
        OnPaymentMethodChanged(method, index)
        {
            // Sincronizar .round al cambiar tipo de método: solo CASH tiene redondeo
            const m = this.paymentMethods[index];
            
            if (m.method !== 'CASH') { this.$set(m, 'round', null); } 
            if (m.method === 'CASH') { this.$set(m, 'round', this.Util.RoundPesos(m.subtotal) - m.subtotal); } 
            this.CalculateSubtotals(index);

            //cambiar método de pago reparto
            if(index == 0 && this.availableDeliveryPaymentMethods && this.paymentMethods.length == 1)
            {
                this.deliveryPaymentMethod = method;
            }

            //TODO: esto deberia buscar todas las propinas
            let tip = this.tips.find(t => t.index === index);
            if(tip) 
            {
                tip.method = this.paymentMethods[index].method;
                if(tip.amount == 'CASH' && tip.method !== 'CASH') tip.total = 0;
                this.RecalculateTip(tip);
            }

            //si es una propina por defecto entonces estará liagada el método de pago 1
            if(index == 0)
            {
                let defaultTip = this.tips.find(t => t.type == 'DEFAULT');
                if(defaultTip) 
                {
                    defaultTip.method = this.paymentMethods[index].method;
                    this.RecalculateTip(defaultTip);
                }
            }

        },
        IsRounded(method){
            const result = parseInt(method.subtotal, 10) || 0;
            return result % 10 === 0;
        },
        SumCashRoundPayment(methods) {
            return (methods || []).reduce((acc, p) => {
                if (p.method !== 'CASH' || p.round == null || p.round === '') return acc;
                const r = Number(p.round);
                return acc + (isNaN(r) ? 0 : r);
            }, 0);
        },
        CalculateSubtotals(index)
        {
            if(this.modalDivide) return;

            this.paymentMethods.forEach((m) => {
                if (m.method !== 'CASH') return;
                
                const hasSubtotal = m.subtotal != null && m.subtotal !== '';

                const subtotalNumber = hasSubtotal ? Number(m.subtotal) : 0;  // ← 0 en vez de NaN
                const orderTotal = this.total.totalMoney - this.discounts.totalDiscount;
                
                const base = (this.paymentMethods.length === 1)
                ? orderTotal
                : subtotalNumber;  // ← Directo, sin chequeo

                if (base > 0) {
                    const rounded = this.Util.RoundPesos(base);
                    this.$set(m, 'round', rounded - base);
                } else {
                    this.$set(m, 'round', null);
                }
            });

            if(this.paymentMethods.length == 2)
            {
                var method = this.paymentMethods[index];
                if(method.subtotal)
                {
                    var total = this.total.totalMoney - this.discounts.totalDiscount;          
                    var method2 = this.paymentMethods[(index+1)%2];
                    
                    if(this.tips.length) {
                        this.tips.forEach(tip => {
                            if(tip.index == index) this.RecalculateTip(tip); 
                        });
                    }

                    if(total - method.subtotal > 0) this.$set(method2, 'subtotal', total - method.subtotal);
                } 
            }
            else if(index < this.paymentMethods.length-1)
            {
                
                var subtotal = 0;
                for(var i = 0; i < this.paymentMethods.length-1; i++)
                {
                    if(this.paymentMethods[i].subtotal){
                        subtotal += this.paymentMethods[i].subtotal;
                    }
                }

                //Ultimo método de pago
                var method = this.paymentMethods[this.paymentMethods.length-1];
                var total = this.total.totalMoney - this.discounts.totalDiscount;
                if(this.tips.length) {
                    let lastTip = this.tips.reduce((maxTip, tip) => tip.index > maxTip.index ? tip : maxTip);
                    this.tips.forEach(tip => {
                        if(tip.index == index) this.RecalculateTip(tip);
                    });

                    if(lastTip.index == (this.paymentMethods.length-1)) lastTip.total 

                    // if(lastTip.index == (this.paymentMethods.length-1)) lastTip.total = (total - subtotal + (round))*(10/100);

                    // Propina 10% del último método (subtotal + round si CASH)
                    if(lastTip.index === this.paymentMethods.length - 1) {
                        const baseForTip = method.method === 'CASH' 
                            ? total - subtotal + (method.round || 0)
                            : total - subtotal;
                            
                        lastTip.total = method.method === 'CASH' 
                            ? this.Util.RoundPesos(baseForTip * 0.1)
                            : baseForTip * 0.1;
                    }
                }

                if(total-subtotal > 0) this.$set(method, 'subtotal', total-subtotal);
                
                if(this.settings.default_tip_table && index === 0) {
                    const method = this.paymentMethods[0];

                    const baseForTip = method.method === 'CASH' 
                        ? (method.subtotal || 0) + (method.round || 0)
                        : (method.subtotal || 0);
                        
                    this.tips[0].total = method.method === 'CASH' 
                        ? this.Util.RoundPesos(baseForTip * 0.1)
                        : baseForTip * 0.1;
                }
            }
        },
        GetOrder()
        {
            if(typeof this.transaction == 'string') return this.Info(this.transaction);
            var data = JSON.parse(JSON.stringify(this.transaction));
            
            const platformValue = (data.custom_data && data.custom_data.platform) || sessionStorage.getItem('platform') || null
            const platform = (!platformValue || platformValue === 'SCHEDULE') ? 'Sin plataforma seleccionada' : platformValue
            
            data.custom_data  = {platform: platform}
            if(this.selectedBrand) data.custom_data.brand = this.selectedBrand;
            data.total_money = this.total.totalMoney + this.roundTotal;
            data.total_discount = this.discounts.totalDiscount;
            data.type = this.sale;
            data.customer = this.customer;

            if(this.sale !== 'DELIVERY')
                data.customer.address = null;
            //if(this.sale !== 'DELIVERY' && (this.sale !== 'TAKEAWAY' && this.takeawayTime))
            //data.customer.phone = null;
        
            data.comment = this.comment ? this.comment : null;
            
            if(this.sale == 'SERVE' && this.table !== null)
                data.table = this.table;
            else if(this.sale == 'SERVE' && this.table == null && this.Util.StringToTime(this.serveTime) && !this.schedule)
                data.activation_time = this.Util.StringToTime(this.serveTime);
            else if(this.sale == 'TAKEAWAY' && this.Util.StringToTime(this.takeaway) && !this.schedule)
                data.activation_time = this.Util.StringToTime(this.takeaway);
            else if(this.sale == 'DELIVERY' && this.Util.StringToTime(this.deliveryTime) && !this.schedule)
                data.delivery_time = this.Util.StringToTime(this.deliveryTime);

            if(this.schedule){ //Sí trae schedule es pedido programado
                data.schedule = this.schedule;
                if(this.sale == 'SERVE' && !this.wasShipment) data.activation_time = this.Util.StringToTime(this.Util.Date(this.schedule, 'HH:mm')); //Sí es pedido programado, lo correcto es que delivery_time conserve la hora y minutos en que se repartirá
                if(this.sale == 'TAKEAWAY' && !this.wasShipment) data.activation_time = this.Util.StringToTime(this.Util.Date(this.schedule, 'HH:mm')); //Sí es pedido programado, lo correcto es que activation_time conserve la hora y minutos en que se retirará
                if(this.sale == 'DELIVERY' && !this.wasShipment) data.delivery_time = this.Util.StringToTime(this.Util.Date(this.schedule, 'HH:mm')); //Sí es pedido programado, lo correcto es que delivery_time conserve la hora y minutos en que se repartirá
            }

            var categories = [];

            if(this.customerAccount && this.customerAccount.id_user)
            {
                data.user = this.customerAccount.id_user;
                data.coupons = this.discounts.coupons;
            }

            
            data.tips = this.tips;

            // Normalizar payment: subtotal guardado = subtotal + round (para que calce con total_money)
            data.payment = data.payment.map(m => ({ ...m, subtotal: (Number(m.subtotal) || 0) + (Number(m.round) || 0), round: (m.round != null && m.round !== '') ? -Number(m.round) : 0 }));
            
            if(this.sale == 'DELIVERY' && this.pedidosYa)
            {
                data.pedidosYa = this.pedidosYa;
                data.pedidosYa.name = this.customer.name;
                data.pedidosYa.phone = this.customer.phone;
                data.pedidosYa.address = this.customer.address;
                data.pedidosYa.email = this.customer.email;
            } 
            console.log("GET ORDER DATA");
            console.log(data);
            return data;
        },
        RegisterOrder(checkErrors)
        {
            if(this.settings.no_payment_select && this.paymentMethods.some(method => method.method == 'NO_SELECT') && !this.table) return this.Info(`Debe seleccionar un método de pago.`);
            if(this.table && this.paymentMethods[0].method == 'NO_SELECT') this.paymentMethods[0].method = this.availablePaymentMethods[1].value;

            if(this.sale == null) return this.Info('Debe seleccionar un Tipo de Pedido');

            if(this.settings.no_payment_select && this.deliveryPaymentMethod == 'NO_SELECT' && this.deliveryCost > 0) return this.Info(`Debe seleccionar un método de pago para pagar el costo reparto.`);

            if(this.minDate.anticipation){
                if(!this.schedule) {
                    this.schedule = this.minDate.dateStart;
                    return this.Info(`Se ha actualizado la fecha del pedido agendado a ${this.minDate.dateStartParse} debido a horas de reserva de productos`);
                }

                if(this.schedule && this.schedule < this.minDate.dateStart){
                    this.schedule = this.minDate.dateStart;
                    return this.Info(`Se ha actualizado la fecha del pedido agendado a ${this.minDate.dateStartParse} debido a horas de reserva de productos`);
                }
            }

            if(checkErrors===undefined) checkErrors = true;
            if(this.pedidosYa && (!this.customer.phone || !this.customer.name)) return this.Info('Nombre y teléfono del cliente son requeridos para Envios por PedidosYa');
            
            if(this.sale == 'SERVE') {
                if(this.table) {
                    this.serveTime = '';
                    this.schedule = null;
                }
                if(this.serveTime || this.schedule) this.table = null;
            }

            //check método de pago unico
            let uniquePaymentMethod = false;

            let onlinePayment = this.paymentMethods.find(el => el.method.startsWith('ONLINE'));

            if (onlinePayment) {
                uniquePaymentMethod = onlinePayment.method;

                if (this.paymentMethods.length > 1) {
                    let methodObj = {
                        ONLINE: 'Pago Online',
                        ONLINE_GETNET: 'Pago Online con Getnet',
                        ONLINE_MERCADO_PAGO: 'Pago Online con Mercado Pago',
                    };

                    return this.Info(`Sólo se permite un método de pago para ${methodObj[onlinePayment.method]}`);
                }
            }

            if(this.transbankPOSIntegrado)
            {
                for(let i = 0; i < this.paymentMethods.length; i++)
                {
                    let method = this.paymentMethods[i];
                    let transbankMethod = this.settings.payment_methods.find(el => el.title == method.method);
                    if(transbankMethod && (transbankMethod.transbank_debit || transbankMethod.transbank_credit))
                    {
                        if(this.paymentMethods.length > 1) return this.Info(`Sólo se permite un método de pago para Transbank POS Integrado`);
                        uniquePaymentMethod = 'TRANSBANK_POS';
                    }
                }
            }

            if(this.mercadopagoPOSIntegrado)
            {
                for(let i = 0; i < this.paymentMethods.length; i++)
                {
                    let method = this.paymentMethods[i];
                    let MPPOS = this.settings.payment_methods.find(el => el.title == method.method);
                    if(MPPOS && MPPOS.title == 'Mercado Pago') {
                        if(this.paymentMethods.length > 1) return this.Info(`Sólo se permite un método de pago para Mercado Pago POS Integrado`);
                        uniquePaymentMethod = 'Mercado Pago';
                    }
                }
            }

            if(this.sale == 'DELIVERY' && this.customer.address_additional) {
                this.customer.address += ` ( ${this.customer.address_additional} )`;
            }

            if(checkErrors)
            {
                if(typeof this.transaction == 'string') return this.Info(this.transaction);
                /*
                if(this.sale == 'DELIVERY' && !this.customer.address) return this.Confirm({
                    title: '¿Ingresar un pedido delivery sin dirección?',
                    text: 'Ingresar',
                    class: 'selected-color',
                    function: () => {this.RegisterOrder(false)}
                });
                */
            }

            var now = this.Util.Date('now', 'timestamp');
            if(this.schedule && this.schedule < now)
            {
                
                    if(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.create_past_transactions || this.pedidosYa)
                    {
                        this.Confirm({
                            text: 'Crear Pedido',
                            title: `¿Crear pedido con fecha pasada ${this.Util.Date(this.schedule, 'HH:mm DD/MM/YYYY')}? El pedido será ingresado como completado`,
                            function: () => {
                                this.Loading();
                                let orderData = this.GetOrder();
                                orderData.uid = this.Util.UUIDv4();
                                axios.put(`/transaction/${this.Local.id}/past`, orderData).then(res => {
                                    this.Reset();
                                    this.Info(`Pedido creado exitosamente`);
                                }).catch(err => {
                                    if(err.message == 'Network Error')
                                        this.CheckIfTransactionCreated(orderData.uid, 'Pedido creado exitosamente');
                                    else
                                        this.Response(err);
                                });
                            }
                        });
                    }
                    else
                    {
                        this.Info('Fecha inválida');
                    }
                    return;
                
                
            }

            let data = this.GetOrder();
            //identificador para verificar pedidos duplicados
            data.uid = this.Util.UUIDv4();
            let deliveryMessage = this.sale == 'DELIVERY' && !this.customer.address;

            if((this.settings.default_paid == 'CUSTOM' || data.schedule) && !uniquePaymentMethod)
            {
                var options = [
                    {
                        text: data.schedule ? `Agendar Pedido Pagado` : 'Ingresar Pedido Pagado',
                        class: deliveryMessage ? 'error-color' : 'selected-color', 
                        function: () => {
                            data.paid = true;
                            this.RegisterOrderRequest(data);
                        },
                        confirm: deliveryMessage ? '¿Ingresar un pedido delivery sin dirección?' : '',
                        icon: 'bill'
                    },
                    {
                        text: data.schedule ? `Agendar Pedido` : 'Ingresar Pedido', 
                        class: deliveryMessage ? 'error-color' : '', 
                        function: () => {
                            data.paid = false;
                            this.RegisterOrderRequest(data);
                        },
                        confirm: deliveryMessage ? '¿Ingresar un pedido delivery sin dirección?' : '',
                        icon: 'receipt'
                    }
                ];
                this.Options(options);
            }
            else
            {
                if(uniquePaymentMethod == 'TRANSBANK_POS')
                {
                    this.$emit('OnTransbankPOSPaymentRequired', data);
                    return;
                }

                if(uniquePaymentMethod == 'Mercado Pago')
                {
                    this.$emit('OnMercadoPagoPOSPaymentRequired', data);
                    return;
                }

                data.paid = this.settings.default_paid == 'CREATED';
                if(deliveryMessage)
                {
                    this.Confirm({
                        title: '¿Ingresar un pedido delivery sin dirección?',
                        text: 'Ingresar',
                        class: 'error-color',
                        function: () => {this.RegisterOrderRequest(data)}
                    });
                }
                else
                    this.RegisterOrderRequest(data);
            }


        },
        RegisterOrderRequest(data)
        {
            this.Loading();
            axios.put(`/transaction/${this.Local.id}`, data).then( ({data}) => {
                if(data.error){
                    if(data.new_estimate){ //Cambió el valor del envío
                        //Se actualiza pedidosya
                        this.pedidosYa.deliveryOfferId = data.new_estimate.deliveryOffers[0].deliveryOfferId;
                        this.pedidosYa.estimateId = data.new_estimate.estimateId;
                        this.pedidosYa.price = data.new_estimate.deliveryOffers[0].pricing;
                        
                        //Se actualiza valor de delivery
                        this.deliveryCost = data.new_estimate.deliveryOffers[0].pricing.total;
                    }
                    return this.Info(data.message);
                }
                this.Reset();
                this.$emit('TransactionSuccess', data);
                this.Response(data);
                if(this.pedidosYa) this.pedidosYa = null;
            }).catch(err => {
                this.Response(err);
            });
        },
        FillFields(parameters){
            this.pedidosYa = parameters;
            this.takeaway = Util.Date(parameters.date, 'HH:mm');
            this.$set(this.customer, 'name', parameters.name);
            this.$set(this.customer, 'phone', parameters.phone);
            this.$set(this.customer, 'address', parameters.address);
            this.$set(this.customer, 'email', parameters.email ? parameters.email : null);
            this.deliveryCost =  parameters.price.total;
            this.schedule = parameters.scheduled ? parameters.date : null;
        },
        LoadTransaction(id) 
        {
            this.Loading();
            axios.get(`/transaction/${id}/orders`).then(res => {
                this.Response(res);
                console.log(res.data);
                if(res.data.length > 0)
                {
                    for(var i = 0; i < res.data.length; i++)
                        this.$emit('AddItem', res.data[i]);
                }
            }).catch(err => {
                this.Response(err);
            });
        },
        SetCustomDiscount(value, isCoupon)
        {
            if(value)
            {
                this.customDiscount = value;
            }
            else
            {
                var code = this.modalDiscount.amount;
                if(isCoupon || (isNaN(code) && code.length >= 5))
                {
                    //buscar codigo de cupon
                    if(!this.canAddCoupon) return this.Info('No se puede agregar cupones de descuento');
                    
                    this.Loading();
                    axios.post(`/coupon/${this.Local.id}/code`, {code: code}).then(res => {
                        this.Response(res);
                        this.coupon = res.data;
                        this.modalDiscount = null;
                    }).catch(err => {
                        this.Response(err);
                    });
                    return;
                }

                if(!this.canAddDiscount) return this.Info('No se puede agregar descuento');
                if(!this.modalDiscount.amount || isNaN(this.modalDiscount.amount.toString().toUpperCase().replace('%', '').replace('X', ''))) return this.Info('Cantidad inválida');
                this.customDiscount = this.modalDiscount.amount.replace('-', '');
                this.modalDiscount = null;
            }
        },
        OpenDividePayment() 
        {

            var order = Object.values(this.value);
            if(!order.length) return this.Info('Pedido inválido');
            var items = [];
            order.forEach(order => {
                for(var i = 0; i < order.quantity; i++)
                    items.push(JSON.parse(JSON.stringify(order)));
            });

            this.discounts.arrDiscounts.forEach(discount => {
                items.push({title: `DESCUENTO ${discount.item || discount.title || ""}: -${this.Util.Price(discount.discount)}`, price: -discount.discount});
            });

            let numberCustomers = this.dictDiners ? Object.keys(this.dictDiners).length : 2;
            if(numberCustomers < 2) numberCustomers = 2;
            
            this.modalDivide = {
                items: items,
                customers: numberCustomers
            }

             this.modalDivide.divisionOptions = [
                {text: 'Dividir total', value: 'TOTAL'},
                {text: 'Dividir en productos', value: 'PRODUCT'},
            ];

            this.modalDivide.divisionOptions = this.modalDivide.divisionOptions.filter(opt => !opt.value.startsWith('BYMETHOD_'));
            const notPaidMethods = this.paymentMethods.filter(m => !m.paid_at && !m.item_paid && m.subtotal > 0);

            if (notPaidMethods.length > 0 && !this.modalDivide.divisionOptions.some(option => option.value === 'NOTPAY')) {
                this.modalDivide.divisionOptions.push({
                    text: 'Dividir los no pagados',
                    value: 'NOTPAY',
                });
            }

            notPaidMethods.forEach((method, index) => {
                const realIndex = this.paymentMethods.indexOf(method); 
                const title = method.diner && method.diner !== 'ALL' ? DictTagDinerName(method.diner) : `Método ${realIndex + 1}`;

                this.modalDivide.divisionOptions.push({
                    text: `Dividir por ${title}`, 
                    value: `BYMETHOD_${realIndex + 1}`, 
                    description: `Método: ${Util.PayMethod(method.method)} - Subtotal: ${this.Util.Price(method.subtotal)}` 
                });
            });

            let unpaidTotalCalc = 0;
            for (let i = 0; i < this.paymentMethods.length; i++) {
                const method = this.paymentMethods[i];
                if (!method.paid_at) {
                    unpaidTotalCalc += method.subtotal || 0;
                }
            }
            this.modalDivide.unpaidTotal = unpaidTotalCalc;
        },
        DividePayment()
        {
            var customers = parseInt(this.modalDivide.customers);
            if(isNaN(customers) || customers < 2) return this.Info('Número de clientes inválido');

            var subtotals = [];
            for(var i = 0; i < customers; i++)
                subtotals.push({money: 0, items: []});
            
            var methods = [];

            if(this.modalDivide && this.modalDivide.divisionOptionSelected === 'PRODUCT'){
                for(var i = 0; i < this.modalDivide.items.length; i++)
                {
                    var item = this.modalDivide.items[i];
                    var itemCustomers = [];
                    for(var j = 1; j <= customers; j++)
                    {
                        if(item['customer-'+j])
                            itemCustomers.push(j);
                    }
                    if(!itemCustomers.length) {
                        return this.Info('Debe haber al menos un cliente seleccionado en todos los items');
                    }
                    if(itemCustomers.length == 1)
                    {
                        subtotals[itemCustomers[0]-1].money += item.price;
                        subtotals[itemCustomers[0]-1].items.push(`100% ${item.title}: ${Util.Price(item.price)}`);
                    }
                    else
                    {
                        var subtotal = parseInt(item.price / itemCustomers.length);
                        //2000 / 3 = 666
                        //660 + 660 = 1320
                        //680
                        var round = Math.floor(subtotal/10)*10;
                        var first = item.price - (round * (itemCustomers.length-1));
                        var isFirst = true;
                        itemCustomers.forEach(customer => {
                            subtotals[customer-1].money += isFirst ? first : round;
                            subtotals[customer-1].items.push(`${Math.floor(round/item.price*100)}% ${item.title}: ${Util.Price(isFirst ? first : round)}`);
                            isFirst = false;
                        });
                    }
                    console.log(subtotals);
                }

                for(var i = 0; i < subtotals.length; i++)
                {
                    methods.push({method: 'CASH', subtotal: subtotals[i].money, cash: null});
                }
            }
            if (this.modalDivide && this.modalDivide.divisionOptionSelected === 'TOTAL') {
                if (this.totalMoney <= 0) return;
                const valuePerCustomer = Math.floor(this.totalMoney / customers / 10) * 10;
                let acumulado = 0;
                for (let i = 0; i < customers; i++) {
                    let amount;
                    if (i === 0) {
                        amount = this.totalMoney - valuePerCustomer * (customers - 1);
                    } else {
                        amount = valuePerCustomer;
                        acumulado += valuePerCustomer;
                    }
                    methods.push({ method: 'CASH', subtotal: amount, cash: null });
                }
            }
            if(this.modalDivide && this.modalDivide.divisionOptionSelected === 'NOTPAY'){
                const paidPaymentMethods = this.paymentMethods.filter(m => m.paid_at || m.item_paid);

                let totalPaid = 0;
                for (let i = 0; i < paidPaymentMethods.length; i++) {
                    totalPaid += paidPaymentMethods[i].subtotal || 0;
                }

                const diff = this.totalMoney - totalPaid;

                if (diff <= 0) {
                    methods = [...paidPaymentMethods];
                } else {
                    const valuePerCustomer  = Math.floor(diff / customers / 10) * 10;
                    let acumulado = 0;
                    const notPaid = [];

                    for (let i = 0; i < customers; i++) {
                        let amount;
                        if (i === 0) {
                            amount = diff - (valuePerCustomer * (customers - 1));
                        } else {
                            amount = valuePerCustomer ;
                            acumulado += valuePerCustomer ;
                        } 
                        notPaid.push({ method: 'CASH', subtotal: amount, cash: null });
                    }

                    methods = [...paidPaymentMethods, ...notPaid];
                }
            }

            if (this.modalDivide && this.modalDivide.divisionOptionSelected.startsWith('BYMETHOD_')) {
                const methodIndex = parseInt(this.modalDivide.divisionOptionSelected.replace('BYMETHOD_', ''), 10) - 1;
                const selectedMethod = this.paymentMethods[methodIndex];

                if (!selectedMethod) {
                    this.Info('No se encontró el método seleccionado');
                    return;
                }

                const total = selectedMethod.subtotal || 0;
                const valuePerCustomer = Math.floor(total / customers / 10) * 10;
                let acumulado = 0;
                const dividedMethods = [];

                for (let i = 0; i < customers; i++) {
                      let amount;
                    if (i === 0) {
                        amount = total - valuePerCustomer * (customers - 1);
                    } else {
                        amount = valuePerCustomer;
                        acumulado += valuePerCustomer;
                    }
                    dividedMethods.push({ method: selectedMethod.method, subtotal: amount, cash: null });
                }

                this.paymentMethods[methodIndex].subtotal = dividedMethods[0].subtotal;

                if (dividedMethods.length > 1) {
                    this.paymentMethods.push(...dividedMethods.slice(1));
                }
            }

            if(!this.modalDivide.divisionOptionSelected.startsWith('BYMETHOD_')){
                this.paymentMethods = methods;
            }

            this.$nextTick(() => {
                this.modalDivide = null;
                this.CalculateSubtotals(0);
            });
        },
        SelectAllCustomers(item)
        {
            const customers = this.modalDivide.customers;
            let allSelected = true;
            for (let i = 1; i <= customers; i++) {
                if (!item[`customer-${i}`]) {
                    allSelected = false;
                    break;
                }
            }
            for (let i = 1; i <= this.modalDivide.customers; i++) {
                this.$set(item, 'customer-' + i, !allSelected);
            }
        },
        /*
        Selecciona un cliente de la lista de busqueda. En caso de ser un cliente influye, descarga los cupones
        */
        SelectCustomer(customer)
        {
            this.hideSearchBox = true;

            if(Array.isArray(customer.items)) customer.items = {};
            this.customerAccount = customer;
            this.$set(this.customer, 'name', customer.name);
            if(customer.phone) this.$set(this.customer, 'phone', customer.phone);
            if(customer.rut) this.$set(this.customer, 'rut', customer.rut);
            if(customer.address && !this.pedidosYa) this.$set(this.customer, 'address', customer.address);
            if(customer.zone && this.settings.customer_auto_select_delivery_cost)
            {
                var zoneValue = null;
                for(var i = 0; i < this.settings.delivery_costs.length; i++)
                {
                    var option = this.settings.delivery_costs[i];
                    if(customer.zone == option.title)
                    {
                        zoneValue = option.value;
                        break;
                    }
                }
                if(zoneValue !== null && this.$refs.selectDeliveryCost)
                    this.$refs.selectDeliveryCost.SelectItem(zoneValue);
            }

            this.isInputReadonlyName = (!customer.name || (this.isAdmin || this.Auth.restrictions.can_edit_name_client))? false : true;
            console.log(customer);
        },
        EditItem(item, index)
        {
            if(!this.canEditItems) return;
            //this.SetItem(item, index, 0);
            this.$emit('OnEditItem', item);
        },
        OpenTip()
        {
            var subtotals = [];
            if(this.total.order !== this.totalMoney)
            {
                subtotals.push({text: `Subtotal Pedido: ${this.Util.Price(this.total.order)}`, value: {total: this.total.order, method: this.paymentMethods[0].method, index: null, target: 'SUBTOTAL'}});
                subtotals.push({text: `Total Pedido: ${this.Util.Price(this.totalMoney)}`, value: {total: this.totalMoney, method: this.paymentMethods[0].method, index: null, target: 'TOTAL'}});
            }
            else
                subtotals.push({text: `Total Pedido: ${this.Util.Price(this.totalMoney)}`, value: {total: this.totalMoney, method: this.paymentMethods[0].method, index: null, target: 'TOTAL'}});
            
            if(this.paymentMethods.length > 1)
            {
                for(var i = 0; i < this.paymentMethods.length; i++)
                {
                    var method = this.paymentMethods[i];
                    if(!isNaN(parseInt(method.subtotal)))
                        subtotals.push({text: `Método Pago ${i+1} (${this.Util.PayMethod(method.method)}): ${this.Util.Price(method.subtotal)}`, value: {total: method.subtotal, method: method.method, index: i, target: 'METHOD'}});
                };
                for(var i = 0; i < this.paymentMethods.length; i++)
                {
                    var method = this.paymentMethods[i];
                    subtotals.push({text: `Total: ${this.Util.Price(this.totalMoney)} (al Método Pago ${i+1})`, value: {total: this.totalMoney, method: method.method, index: i, target: 'TOTAL'}});
                };
                subtotals.push({text: `Total: ${this.Util.Price(this.totalMoney)} (dividido en ${this.paymentMethods.length} métodos de pago)`, value: {total: this.totalMoney, method: 'AUTO', index: 'SPLIT', target: 'TOTAL'}});
                subtotals.push({text: `Total: ${this.Util.Price(this.totalMoney)} (a cada método de pago)`, value: {total: this.totalMoney, method: 'AUTO', index: 'DUPLICATE', target: 'TOTAL'}});
                subtotals.push({text: `Cada método de pago`, value: {total: this.totalMoney, method: 'AUTO', index: 'EACH_METHOD', target: 'METHOD'}});
            }
        
            var methods = this.Util.Copy(this.availablePaymentMethods);
            methods.push({text: 'Auto', value: 'AUTO'});

            this.modalTips = {
               subtotal: subtotals[0].value,
               subtotals: subtotals,
               amount: '10%', 
               method: subtotals.length ? subtotals[0].value.method : this.availablePaymentMethods[0].value,
               methods: methods
            };
        },
        AddTip()
        {
            if(this.modalTips.method == 'NO_SELECT') return this.Info("Debe seleccionar un método de pago para la propina.")
            if(this.modalTips.method == 'AUTO' && (this.settings.no_payment_select && this.paymentMethods.some(method => method.method == 'NO_SELECT'))) return this.Info("Debe seleccionar un método de pago para el pedido.")

            if(!this.tip) return this.Info('Propina inválida');
            var tips = [];
            let amount = this.modalTips.amount.toString().toUpperCase().replace('X', '%');
            if(this.modalTips.subtotal.index == 'DUPLICATE')
            {
                for(var i = 0; i < this.paymentMethods.length; i++)
                {
                    tips.push({
                        method: this.modalTips.method,
                        amount : amount.indexOf('%') > -1 ? amount : '',
                        total: this.tip,
                        index: i,
                        target: this.modalTips.subtotal.target,
                    });
                }
            }
            else if(this.modalTips.subtotal.index == 'SPLIT')
            {
                let eachPercent = (parseFloat(amount.replace('%', '')))/this.paymentMethods.length;
                var subtotals = this.Util.DivideInteger(this.tip, this.paymentMethods.length);
                for(var i = 0; i < this.paymentMethods.length; i++)
                {
                    tips.push({
                        method: this.modalTips.method,
                        amount : amount.indexOf('%') > -1 ? `${eachPercent.toFixed(2)}%` : '',
                        total: subtotals[i],
                        index: i,
                        target: this.modalTips.subtotal.target,
                    });    
                }
            }
            else if(this.modalTips.subtotal.index == 'EACH_METHOD')
            {
                for(var i = 0; i < this.paymentMethods.length; i++)
                {
                    let tip = {
                        method: this.modalTips.method,
                        amount : amount,
                        total: this.tip,
                        index: i,
                        target: this.modalTips.subtotal.target,
                    };
                    this.RecalculateTip(tip);
                    tips.push(tip);
                }
            }
            else
            {
                tips.push({
                    method: this.modalTips.method,
                    total: this.tip,
                    amount : this.modalTips.amount.toString().toUpperCase().replace('X', '%'),
                    index: this.modalTips.subtotal.index,
                    target: this.modalTips.subtotal.target,
                });
            }

            tips.forEach(tip => {
                if(tip.method == 'AUTO')
                {
                    if(tip.index === null)
                        tip.method = this.paymentMethods[0].method;
                    else
                        tip.method = this.paymentMethods[tip.index].method;
                }
                if(tip.method == 'CASH' && tip.total > 0) tip.total = this.Util.RoundPesos(tip.total);
                this.tips.push(tip);
            });

            this.modalTips = null;
        },
        MethodChange(method, index)
        {
            var cash = parseInt(method.cash);
            if(isNaN(cash)) return false;
            
            var total = this.paymentMethods.length == 1 
                ? this.total.totalMoney - this.discounts.totalDiscount + this.roundTotal 
                : parseInt(method.subtotal);

            if(isNaN(total)) return false;

            total += this.paymentMethods.length == 1 ? this.totalTips : this.MethodTip(index) || 0;
            // if(this.paymentMethods.length == 1)
            //     total += this.totalTips;
            // else
            // {
            //     total += this.MethodTip(index);
            // }

            return cash >= total ? this.Util.RoundPesos(cash - total) : false;
        },
        MethodTip(index)
        {
            var totalTip = 0;
            for(var i = 0; i < this.tips.length; i++)
            {
                if(this.tips[i].index === index)
                    totalTip += this.tips[i].total;
            }
            return totalTip > 0 ? totalTip : false;
        },
        // CouponDiscountType(coupon)
        // {
        //     if(coupon.discount == 'DELIVERY') return 'Delivery Gratis';
        //     if(coupon.discount.indexOf('%') > -1) return `${coupon.value}% DCTO ${coupon.discount.indexOf('ITEM') > -1 ? '(en productos)' : '(sobre el total)'}`;
        //     else if(coupon.discount == 'ITEM_MINUS') return `Productos a ${Util.Price(coupon.value)}`;
        //     return `${Util.Price(coupon.value)} DCTO ${coupon.discount.indexOf('ITEM') > -1 ? '(en productos)' : '(sobre el total)'}`;
        // },
        CouponItemsRule(coupon)
        {
            if(coupon.discount == 'PER_PRODUCT') return '';
            if(coupon.discount.indexOf('ITEM') == -1)
            {
                if(coupon.items_rule == 'ALL') return 'Si contiene todos los productos';
                else if(coupon.items_rule == 'SOME') return 'Si contiene al menos un producto';
            }
            else
            {
                if(coupon.items_rule == 'ALL') return 'A cada producto';
                if(coupon.items_rule == 'INDEX_1') return 'Al primero de cada producto';
                if(coupon.items_rule == 'INDEX_2') return 'Al segundo de cada producto';
                if(coupon.items_rule == 'INDEX_3') return 'Al tercero de cada producto';
                if(coupon.items_rule == 'INDEX_4') return 'Al cuarto de cada producto';
                if(coupon.items_rule == 'EVERY_2') return 'Cada dos productos iguales';
                if(coupon.items_rule == 'EVERY_3') return 'Cada tres productos iguales';
                if(coupon.items_rule == 'INDEX_1_SELECTION') return 'Al primer producto de los seleccionados';
                if(coupon.items_rule == 'INDEX_2_SELECTION') return 'Al segundo producto de los seleccionados';
                if(coupon.items_rule == 'INDEX_3_SELECTION') return 'Al tercer producto de los seleccionados';
                if(coupon.items_rule == 'INDEX_4_SELECTION') return 'Al cuarto producto de los seleccionados';
                if(coupon.items_rule == 'EVERY_2_SELECTION') return 'Cada dos productos de los seleccionados';
                if(coupon.items_rule == 'EVERY_3_SELECTION') return 'Cada tres productos de los seleccionados';
            }
            return '';
        },

        SelectSearchAddress(event)
        {
            console.log(event);
            if(!event || typeof event == 'string')
            {
                event = {
                    address: event, 
                    search: event,
                    lat: null,
                    lon: null
                };
            }

            this.$set(this.customer, 'address', this.CleanAddress(event.title));
            // this.$set(this.customer, 'address', event.title);
            // this.$set(this.customer, 'address', event.search);
            if(event.lat) this.$set(this.customer, 'maps_address', event.title);
            this.$set(this.customer, 'latitude', event.lat);
            this.$set(this.customer, 'longitude', event.lon);
            if('cost' in event) this.deliveryCost = event.cost;
        },

        CleanAddress(address) {
            let cleanAddress = this.Util.Copy(address);
            const parts = cleanAddress.split(',');

            if(parts.length < 2) return cleanAddress;

            const street = parts[0].trim();
            let second = parts[1].trim();

            const isFormat1 = !/\d/.test(second);

            const isFormat2 = /^\d+/.test(second);

            if(isFormat1) {
                cleanAddress = `${street}, ${second}`;
            } else if(isFormat2) {
                let comuna = second.replace(/^\d+\s*/, '').trim();

                cleanAddress = `${street}, ${comuna}`;
            } else {
                cleanAddress = address;
            }

            return cleanAddress;
        },
        openModalPya(){
            var data = {
                customer: this.customer
            };
            if(this.selectedBrand) data.brand = this.selectedBrand;
            this.$refs.estimatePya.Open(data);
        },
        ChangeSale(type){
            this.sale = type;

            //checkear propina por defecto
            if(this.setDefaultTip && !this.hasDeletedDefaultTip)
            {
                this.tips = this.tips.filter(tip => tip.type !== 'DEFAULT');
                if(type && this.settings[`default_tip_${type.toLowerCase()}`])
                    this.tips.push({total: 0, type: 'DEFAULT', method: this.paymentMethods[0].method, amount: '10%', target: 'TOTAL', index: null});
            }

            this.$emit('OnSaleChanged', type);
            
            if(type == 'DELIVERY'){
                this.CheckDeliveryRules(this.total.order)
            }
        },
        ClearFields(field){
            if(this.isAdmin || this.Auth.restrictions.can_edit_name_client){
                this.customer[field] = null;
            }else{
                this.isInputReadonlyName = false;
                this.customer.name = null;
                this.customer.phone = null;
                this.customer.rut = null;
            }
        },
        CheckDeliveryRules(totalOrder) {
            let rules = this.settings.delivery_rules ? Util.Copy(this.settings.delivery_rules) : [];

            if (!rules.length) {
                this.activeRule = null;
                return;
            }

            let candidates = rules.filter(rule => {
                let condition = rule ? rule.condition : 0;
                return condition <= totalOrder;
            });

            if (!candidates.length) {
                this.activeRule = null;
                return;
            }

            // zona actual seleccionada
            let currentZone = null;
            if (this.$refs.selectDeliveryCost && this.$refs.selectDeliveryCost.currentItem) currentZone = this.$refs.selectDeliveryCost.currentItem.title;

            let chosen = null;
            for (let i = candidates.length - 1; i >= 0; i--) {
                let rule = candidates[i];
                let zones = rule && rule.delivery_zones ? rule.delivery_zones : [];

                let applies = false;
                if (zones.length == 0) {
                    // sin restricción de zonas => aplica
                    applies = true;
                } else if (currentZone) {
                    // con restricción: debe incluir la zona actual
                    applies = zones.indexOf(currentZone) !== -1;
                }

                if (applies) {
                    chosen = rule;
                    break;
                }
            }
            this.activeRule = chosen;
        },

        NoLetterAllowed(index){
            let onlyNumbers = this.paymentMethods[index].n_transfer.replace(/\D/g, '');
            this.paymentMethods[index].n_transfer = onlyNumbers
            if (this.$refs[`nTransfer_${index}`]) {
                this.$refs[`nTransfer_${index}`].currentValue = onlyNumbers
            }
        },
        
        EditCustomerPhone(){
            this.Loading();
            axios.patch(`/customer/${this.Local.id}/${this.customer.phone}`, this.customer).then(res => {
                this.Response(res);
                this.modalEditPhone = false;
                this.SelectCustomer(res.data)
                // this.$emit('OnCustomerEdit', res.data);
            }).catch(err => {
                this.Response(err);
            });
        },
        RegisterPartialPayment(index){
            if(!this.paymentMethods[index].subtotal || this.paymentMethods[index].subtotal == 0 || this.paymentMethods[index].paid_at) return
            this.$set(this.paymentMethods[index], 'paid_at', Util.Date('now', 'timestamp'))
            this.$set(this.paymentMethods[index], 'paid_by', this.Auth.name)
        },
        DeletePartialPayment(index){
            if(!this.paymentMethods[index].subtotal || this.paymentMethods[index].subtotal == 0 || !this.paymentMethods[index].paid_at) return
            this.$delete(this.paymentMethods[index], 'paid_at')
            this.$delete(this.paymentMethods[index], 'paid_by')
        },
        ToggleBtnNTransfer(index){
            this.$set(this.paymentMethods[index], 'showBtnNTransfer', !this.paymentMethods[index].showBtnNTransfer);
        },
        ShowMethodNumberButton(method) 
        {

            let invalidMethods = ['CASH', 'NO_SELECT', 'ONLINE', 'ONLINE_GETNET', 'ONLINE_MERCADO_PAGO'];
            if(invalidMethods.includes(method.method)) return false;

            if(!this.transankPOSIntegrado) return true;

            let methodSettings = this.settings.payment_methods.find(el => el.title == method.method);
            if(methodSettings && (methodSettings.transbank_credit || methodSettings.transbank_debit)) return false;
            
        },
        ChangePriceTempItem(){

            //Checkear si hay algun cambio de precio
            let hasChangeItemPrice = Object.values(this.modalChangePriceItem.items).some(item => item.price !== item.original_price);
            let hasInvalidPrice = Object.values(this.modalChangePriceItem.items).some(item => item.price < 1 || !item.price);

            if(hasChangeItemPrice) this.Info("Precios han sido modificados");
            if(hasInvalidPrice) return this.Info("Precio inválido.")

            Object.values(this.modalChangePriceItem.items).forEach(item => {
                item.total_money = item.quantity * item.price;
                if(item.modifiers.length > 0) {
                    item.modifiers.forEach(modifier => {
                        // Se asigna 0 al precio del modificador para que en la impresión no se sume con el precio del item.
                        modifier.price = 0;
                    });
                }
            });

            //Este evento permite modificar el "value" del componente
            this.$emit('input', this.modalChangePriceItem.items);
            
            this.modalChangePriceItem = null;
        },
        OpenModalChangePriceItem(){
            let copyItems = this.Util.Copy(this.value);

            Object.values(copyItems).forEach(item => {
                // Se agregan las variables cuando no existen los original_price y value_price
                if(!item.original_price) item.original_price = item.price;
                if(!item.value_price) item.value_price = item.price.toString();
            });

            // this.$emit('input', copyItems);
            this.modalChangePriceItem = {items : copyItems };
        },
        SetupScrollListener()
        {
            if(this.observer)
            {
                this.observer.disconnect();
                this.observer = null;   
            }
            if(this.parentScrollEl) this.parentScrollEl.removeEventListener('scroll', this.IsScrolledToBottom);

            this.parentScrollEl = this.Util.GetNearestScrollableParent(this.$el);
            this.IsScrolledToBottom();
            this.hasScroll = this.parentScrollEl.scrollHeight > this.parentScrollEl.clientHeight;
            this.observer = new MutationObserver(() => {
                this.hasScroll = this.parentScrollEl.scrollHeight > this.parentScrollEl.clientHeight;
                this.IsScrolledToBottom();
            });
            this.observer.observe(this.parentScrollEl, {childList: true, subtree: true, characterData: true});
            this.parentScrollEl.addEventListener('scroll', this.IsScrolledToBottom);
        },
        IsScrolledToBottom()
        {
            this.isScrollAtBottom = this.Util.IsScrolledToBottom(this.parentScrollEl);
        },
        CheckIfTransactionCreated(uid, successMessage)
        {
            axios.get(`/transaction/check/${uid}`).then(res => {
                this.Reset();
                if(successMessage)
                {
                    this.Info(successMessage);
                }
                else
                {
                    if(res.data.transaction)
                        this.$emit('TransactionSuccess', res.data.transaction);
                    this.Response(res.data);
                }
            }).catch(err => {
                if(err.message == 'Network Error')
                {
                    setTimeout(() => {
                        this.CheckIfTransactionCreated(uid, successMessage);
                    }, 2000);
                } 
                else
                {
                    console.log(err);
                    this.Response(err);
                }
            });
        },
        RecalculateTip(tip)
        {
            console.log(tip);
            if(typeof tip == 'number')
            {
                tip = this.tips.find(el => el.index === tip);        
            }

            let amount = tip.amount ? tip.amount : tip.total.toString();
            if(!tip || !amount) return;

            let match = amount.match(/^(\d+(?:\.\d+)?)%$/); // Detecta "10%", "12.5%", etc.
            let method = null;

            if (tip.index !== null && tip.index >= 0 && tip.index < this.paymentMethods.length) {
                method = this.paymentMethods[tip.index];
            } else if (tip.index === null && this.paymentMethods.length >= 1) {
                method = this.paymentMethods[0];
            }

            let subtotal;
            if (tip.target === 'SUBTOTAL') {
                subtotal = this.total.order;
            } else if (tip.target === 'ORDER_TOTAL' || tip.target === 'TOTAL') {
                subtotal = this.totalMoney;
                if (method && method.method === 'CASH') {
                    subtotal += method.round != null ? method.round : 0;
                }
            } else {
                subtotal = (method && this.paymentMethods.length > 1 ? method.subtotal : this.totalMoney);
                if (method && method.method === 'CASH') {
                    subtotal += method.round != null ? method.round : 0;
                }
            }

            if (match) {
                let percentage = parseFloat(match[1]) / 100;
                tip.total = parseInt(subtotal * percentage);
            }
            else if(parseInt(amount) < 0)
            {
                tip.total = -parseInt(amount) - subtotal;
                if(tip.total < 0) tip.total = 0;
            }
            else if(amount == 'CASH')
            {
                if(!method.cash || method.cash < subtotal) tip.total = 0;
                tip.total = method.cash - subtotal;
                if(method && method.method !== 'CASH') tip.total = 0;
            }
            
            if ((method && method.method === 'CASH') || tip.method == 'CASH') tip.total = this.Util.RoundPesos(tip.total);
        },
        DeleteOrderPayment(index){
            let toDelete = this.paymentMethods[index];
            if(toDelete['id_payment']){ // Solo en vista de "TABLES"
                 // Método de pago para eliminar.

                // Verificamos los items que estan pagados que coinciden con el pago a eliminar
                let modifyOrders = Object.values(this.value)
                .filter(item => !(item.type === 'LEY_REDONDEO' && item.paid_at === toDelete.paid_at))
                .map(item => {

                    if (item.paid_at === toDelete.paid_at) {
                         // Verifica los items que estan pagados 
                        let { id_payment, paid_at, ...rest } = item; // Elimina las claves específicas, id_payment y paid_at. Se dejan las otras propiedades del objeto
                        return rest;
                    }
                    return item;
                });

                // Se actualiza los items
                this.$emit('input', modifyOrders);
                // Se saca el metodo de pago seleccionado
                this.paymentMethods.splice(index, 1);

                if(this.paidDiscounts && this.paidDiscounts.length) this.paidDiscounts = this.paidDiscounts.filter(item => item.id_payment !== toDelete.id_payment);

                // Eliminacion de propinas
                if(this.tips.length){
                    let tips = this.tips.filter(tip => tip.index != index);
                    if(tips.length) {
                        tips.forEach(tip => {
                            // Se asigna nuevamente el index de la propina con el su pago correspondiente
                            // Esto porque al momneto de eliminar un pago, cambia su posicion dentro del array de pagos
                            let indexPayment = this.paymentMethods.findIndex(payment => payment.paid_at === tip.created_at);
                            tip.index = indexPayment;
                        });
                    }
                    this.tips = tips;
                }

                //Se recalcula los subtotales
                this.$nextTick(() => {
                    if(this.paymentMethods){
                        for (let index = 0; index < this.paymentMethods.length; index++) {
                            this.CalculateSubtotals(index);
                        }    
                    }
                })

            }else{ // Si es por POS.
                this.paymentMethods.splice(index, 1); // Se saca el elemento para eliminar
                this.$nextTick(() => {
                    // POS Al eliminar un método de pago también hay que recalcular subtotales/round
                    if(this.paymentMethods){
                        for (let index = 0; index < this.paymentMethods.length; index++) {
                            this.CalculateSubtotals(index);
                        }    
                    }
                });
            }
        },
        OpenModalDiscount(){
            // Abre el modal de ingreso de descuento y cupon
            this.$refs.modalDiscount.modalDiscount = {amount: this.customDiscount?this.customDiscount:''};
            this.$refs.modalDiscount.customDiscount = this.customDiscount;
        },
        UpdateDiscounts(discount, operation) {
            let isCoupon = typeof discount === 'object';
            let key = isCoupon ? 'coupon' : 'customDiscount';

            switch (operation) {
                case 'save':
                    this.$set(this, key, discount);
                    break;
            
                case 'delete':
                    this.$set(this, key, null);
                    break;
            }

            for (let index = 0; index < this.paymentMethods.length; index++) {
                this.CalculateSubtotals(index);   
            } 

        },
        CloseModalDiscount(){
            // Cierra el modal de ingreso de descuento y cupon
            this.$refs.modalDiscount.modalDiscount = null;
            this.$refs.modalDiscount.customDiscount = null;
        },
        SelectAllCustomersForAllItems() {
            let allSelectedGlobal = true;
            for (let item of this.modalDivide.items) {
                for (let i = 1; i <= this.modalDivide.customers; i++) {
                    if (!item[`customer-${i}`]) {
                        allSelectedGlobal = false;
                        break;
                    }
                }
                if (!allSelectedGlobal) break;
            }
            this.modalDivide.items.forEach(item => {
                for (let i = 1; i <= this.modalDivide.customers; i++) {
                    this.$set(item, 'customer-'+i, !allSelectedGlobal);
                }
            });
        },
        IsAllCustomersSelected(item = null) {
            if (item) {
                for (let i = 1; i <= this.modalDivide.customers; i++) {
                    if (!item['customer-' + i]) {
                        return false;
                    }
                }
                return true;
            } else {
                return this.modalDivide.items.every(it => {
                for (let i = 1; i <= this.modalDivide.customers; i++) {
                    if (!it['customer-' + i]) {
                    return false;
                    }
                }
                return true;
                });
            }
        },
    },
    computed: {
        selectedPaymentMethod() {
            if (!this.modalDivide || !this.modalDivide.divisionOptionSelected.startsWith('BYMETHOD_')) return null;
            const methodIndex = parseInt(this.modalDivide.divisionOptionSelected.replace('BYMETHOD_', ''), 10) - 1;
            return this.paymentMethods[methodIndex] || null;
        },
        orderedItems() {
            var items = Object.values(this.value);

            let deletedItems = "";

            if(this.sale){
                items.forEach(item => {
                    const typeKey = (this.sale == 'DELIVERY') ? 'hide_delivery' : 'hide_takeaway';
                    
                    if (item.combo) {
                        let deleteCombo = false;
                        item.modifiers.forEach(subitem => {
                            if (subitem['section_' + typeKey] || (!subitem['section_' + typeKey] && subitem[typeKey]) || (subitem.anticipation && this.sale == 'SERVE')) deleteCombo = true;
                        });
                        if(item.anticipation && this.sale == 'SERVE') deleteCombo = true;
                        if (deleteCombo) {
                            deletedItems += `<li>${item.title}</li>`;
                            this.$delete(this.value, item.key);
                        }
                    } else {
                        if (item['section_' + typeKey] || (!item['section_' + typeKey] && item[typeKey]) || (item.anticipation && this.sale == 'SERVE')) {
                            deletedItems += `<li>${item.title}</li>`;
                            this.$delete(this.value, item.key);
                        }
                    }
                });
            }

            if(deletedItems != "") this.Info(`<div class='mb10 bold ta-center'>Se quitaron items del pedido no disponibles para ${this.Util.SaleType[this.sale]}</div><ul>${deletedItems}</ul>`);

            return Object.values(this.value).sort((a, b) => {
                return a.timestamp - b.timestamp;
            });
        },
        total() {
            var total = 0;
            var count = 0;
            var totalNoPaid = 0;
            for(var key in this.value)
            {
                count += this.value[key].quantity;
                total += this.value[key].total_money;
                if(!this.value[key].paid_at) totalNoPaid += this.value[key].total_money;
            }

            var delivery = 0;
            if(this.sale == 'DELIVERY' && this.deliveryCost && this.deliveryCost > 0)
                delivery = parseInt(this.deliveryCost);
            
            if(this.sale == 'DELIVERY' && this.settings.delivery_rules && this.settings.delivery_rules.length > 0 && !this.pedidosYa){
                //TODO: no se deberia recalcular cosas en una computada!
                this.CheckDeliveryRules(total);
                delivery = this.activeRule ? this.activeRule.cost : this.deliveryCost;
            }
            
            let partialPayments = 0

            this.totalAlreadyPaid = 0;
            this.paymentMethods.forEach(pay => {
                if (!this.isDiner && pay.paid_at) this.totalAlreadyPaid += pay.subtotal; //Pagados en "PEDIDOS"
                if (pay.paid_at && !pay.item_paid) partialPayments += pay.subtotal; //Pagados parcialmente
            })
            if(partialPayments > 0) totalNoPaid = totalNoPaid - partialPayments; // Si hay pagos parciales, se suman al total pagado
            
            return {totalMoney: total + delivery, items: count, order: total, totalNoPaid : totalNoPaid + delivery};
        },
        discounts() {
            return this.Util.CalculateDiscounts({
                simplifiedData : this.simplifiedData = {},
                value: this.value,
                coupon: this.coupon,
                total: this.total,
                deliveryCost: this.deliveryCost,
                paymentMethods: this.paymentMethods,
                sale: this.sale,
                Local: this.Local,
                paidDiscounts: this.paidDiscounts,
                customDiscount: this.customDiscount,
                pedidosYa: this.pedidosYa,
                isDiner: this.isDiner,
                totalAlreadyPaid: this.totalAlreadyPaid,
            });
        },
        availablePaymentMethods() {
            var ret = [];

            let methods = [
                {
                    method: 'NO_SELECT',
                    enabled: this.settings.no_payment_select,
                },
                {
                    method: 'CASH',
                    enabled: this.settings.accept_cash,
                    missing: ['CASH'],
                },
                {
                    method: 'BANK_DEPOSIT',
                    enabled: this.settings.accepts_bank_deposit,
                    missing: ['BANK_DEPOSIT', 'Transferencia'],
                },
                {
                    method: 'ONLINE',
                    enabled: this.settings.accepts_online_payment,
                    missing: ['ONLINE'],
                },
                {
                    method: 'ONLINE_GETNET',
                    enabled: this.settings.accepts_online_payment_getnet,
                    missing: ['ONLINE_GETNET'],
                },
                {
                    method: 'ONLINE_MERCADO_PAGO',
                    enabled: this.settings.accepts_online_payment_mercado_pago,
                    missing: ['ONLINE_MERCADO_PAGO'],
                },
            ];

            methods.forEach(({ method, enabled, missing = [] }) => {
                if (enabled || missing.some(key => this.missingPaymentMethods[key])) {
                    ret.push({text: this.Util.PayMethod(method), value: method});
                }
            });
            
            for(var i = 0; i < this.settings.payment_methods.length; i++)
                ret.push({text: `${this.Util.PayMethod(this.settings.payment_methods[i].title)}`, value: this.settings.payment_methods[i].title});

            //missing payment methods
            if(this.missingPaymentMethods)
            {
                for(let key in this.missingPaymentMethods)
                {
                    //if(key == 'Transferencia') key = 'BANK_DEPOSIT';
                    if(!ret.find(el => {return el.value == key})) ret.push({text: key, value: key});
                }
            }

            if(this.settings.payment_methods_order.length == 0){
                return ret
            }

            let auxArrayMethods = []
            auxArrayMethods = ret
            let indexMap = {};
            this.settings.payment_methods_order.forEach((obj, index) => {
                indexMap[obj] = index;
            });

            ret = auxArrayMethods.sort((x, y) => indexMap[x.value] - indexMap[y.value]);

            return ret
        },

        /** se incluye NO_SELECT cuando algún método de pago es NO_SELECT (desde invoice_helper), sin depender de settings.no_payment_select. */
        paymentMethodSelectItems() {
            const list = this.availablePaymentMethods;
  
            if (!this.paymentMethods.some(m => m && m.method === 'NO_SELECT') || 
                list.some(item => item.value === 'NO_SELECT')) {
                return list;
            }
            
            return [{ 
                text: this.Util.PayMethod('NO_SELECT'), 
                value: 'NO_SELECT' 
            }, ...list];
        },
        availableDeliveryPaymentMethods() {
            if(this.sale !== 'DELIVERY' || !this.deliveryCost || !this.availablePaymentMethods || !this.availablePaymentMethods.length) return null;
            return this.availablePaymentMethods;
        },
        pendingPaymentMethods() {
            var ret = {'CASH': false};
            for(var i = 0; i < this.settings.payment_methods.length; i++)
                ret[this.settings.payment_methods[i].title] = this.settings.payment_methods[i].pending_payment;
            return ret;
        },
        transaction() {
            var orders = [];
            var discounts = [];
            var payment = [];
            var categories = {};

            /*
            for(var key in this.value)
            {
                var item = this.value[key];
                var itemData = {
                    id: item.id,
                    title: item.title,
                    price: parseInt(item.price),
                    modifiers: item.modifiers,
                    quantity: item.quantity,
                    total_money: parseInt(item.total_money),
                    autocomplete: item.autocomplete,
                    comment: item.comment ? item.comment : null,
                    section: item.section ? item.section : null
                };

                if(item.tag) itemData[item.tag] = true;

                orders.push(itemData);
                for(var categoryID in item.categories)
                    categories[categoryID] = this.categories[categoryID].title;
            }
            */
            this.orderedItems.forEach(item => {
                var itemData = {
                    id: item.id,
                    key : item.key,
                    title: item.title,
                    price: parseInt(item.price),
                    original_price : parseInt(item.original_price),
                    value_price : item.value_price,
                    modifiers: item.modifiers,
                    quantity: item.quantity,
                    total_money: parseInt(item.total_money),
                    autocomplete: item.autocomplete,
                    comment: item.comment ? item.comment : null,
                    section: item.section ? item.section : null,
                    added_at: item.added_at ? item.added_at : null,
                    created_at: item.created_at ? item.created_at : null,
                    wholesale_price : item.wholesale_price,
                    modifiers_price : item.modifiers_price,
                    combo : !!item.combo
                };

                if(item.tag) itemData[item.tag] = true;
                if(item.combo) itemData.combo = true;
                if(item.type) itemData.type = item.type;
                if(item.diner) itemData.diner = item.diner;

                orders.push(itemData);
                for(var categoryID in item.categories)
                    categories[categoryID] = this.categories[categoryID].title;
            });
            
            if(orders.length == 0) return 'No hay items seleccionados';

            //Agregar costo de delivery
            var deliveryCost = this.activeRule ? this.activeRule.cost : (this.deliveryCost && this.deliveryCost > 0 ? parseInt(this.deliveryCost) : 0);
            if(this.sale == 'DELIVERY' && deliveryCost > 0)
            {

                var zone = null;
                for(var i = 0; i < this.settings.delivery_costs.length; i++)
                {
                    if(deliveryCost == this.settings.delivery_costs[i].value)
                    {
                        zone = this.settings.delivery_costs[i].title;
                        break;
                    }
                }
                var deliveryOrder = {
                    id: null,
                    title: 'Reparto',
                    price: deliveryCost,
                    modifiers: [],
                    quantity: 1,
                    total_money: deliveryCost,
                    autocomplete: 1,
                    zone: zone,
                    type: 'DELIVERY',
                    method: this.availableDeliveryPaymentMethods ? this.deliveryPaymentMethod : (this.paymentMethods && this.paymentMethods.length ? this.paymentMethods[0].method : null)
                };
                if(this.isExternalDelivery) deliveryOrder.external = true;
                orders.push(deliveryOrder);
            }

            
            //for(var i = 0; i < this.discounts.arrDiscounts.length; i++)
            //    discounts.push({title: this.discounts.arrDiscounts[i].item, discount: this.discounts.arrDiscounts[i].discount});
            discounts = this.discounts.arrDiscounts;
            let paymentMethods = this.Util.Copy(this.paymentMethods);
            if(paymentMethods.length == 1)
            {
                var payment1 = paymentMethods[0];
                payment1.subtotal = this.total.totalMoney-this.discounts.totalDiscount;
                payment = [payment1];
            } 
            else {
                payment = paymentMethods;  
            }
                

            var pendingPayment = false;
            var totalPayment = 0;
            for(var i = 0; i < payment.length; i++)
            {
                if(payment.length > 1 && payment[i].subtotal === 0) return `El subtotal del método de pago ${i+1} debe ser mayor que $0`;

                payment[i].subtotal = parseInt(payment[i].subtotal);
                if(isNaN(payment[i].subtotal) || payment[i].subtotal < 0) return `El subtotal del método de pago ${i+1} debe ser mayor que $0`;
                totalPayment += payment[i].subtotal + (payment[i].method === 'CASH' ? (Number(payment[i].round) || 0) : 0);

                if(!payment[i].showBtnNTransfer || ['CASH', 'ONLINE', 'ONLINE_GETNET', 'ONLINE_MERCADO_PAGO'].indexOf(payment[i].method) > -1) delete payment[i]['n_transfer'];
                delete payment[i]['showBtnNTransfer'];

                if(this.pendingPaymentMethods[payment[i].method])
                {
                    if(pendingPayment === true) return 'No es posible seleccionar dos métodos de pago pendientes';   
                    pendingPayment = true;
                }

                if(payment[i].method == 'CASH')
                {
                    if(payment[i].cash)
                    {
                        if(isNaN(payment[i].cash) || (payment[i].cash - payment[i].subtotal < 0))
                            delete payment[i].cash;
                    }
                    else
                        delete payment[i].cash;
                }
                else
                {
                    if(payment[i].cash !== undefined) delete payment[i]['cash'];
                }

            }

            let total = this.total.totalMoney - this.discounts.totalDiscount;
            const sumRound = this.SumCashRoundPayment(this.paymentMethods);
            const totalToReach = total + sumRound;

            if(totalPayment != totalToReach) 
            {
                let diff = totalToReach - totalPayment;
                
                const msg = (payment.length > 1 ? `La suma de los subtotales de los ${payment.length} métodos de pago` : 'El subtotal') + ` debe ser igual a ${this.Util.Price(totalToReach)}` + (payment.length > 1 ? ` (${diff < 0 ? 'sobran' : 'faltan'} ${this.Util.Price(Math.abs(diff))})` : '');
                
                return msg;
            }

            const cashIndices = payment.map((p, i) => i).filter(i => payment[i].method === 'CASH');
            
            if (cashIndices.length > 0) {
                let totalRound = 0;
                
                 // caso 1 un solo metodo CASH → redondeo directo
                if (payment.length === 1 && payment[0].method === 'CASH') {
                    const dec = parseInt(total.toString().slice(-1)) || 0;
                    totalRound = dec >= 1 && dec <= 5 ? -dec : (dec >= 6 && dec <= 9 ? 10 - dec : 0); 
                    payment[0].round = totalRound; 
                }
                // Varios métodos: suma .round de cada línea (solo efectivo).
                else {
                    totalRound = this.SumCashRoundPayment(payment);
                }

                if (!isNaN(totalRound) && totalRound !== 0) {
                    orders.push({
                        id: null,
                        title: 'Ley Redondeo',
                        price: totalRound,
                        modifiers: [],
                        quantity: 1,
                        total_money: totalRound,
                        autocomplete: 1,
                        type: 'LEY_REDONDEO',
                    });
                }
            }

            return {
                orders: orders,
                discounts: discounts,
                payment: payment,
                categories: Object.values(categories),
                pending_payment: pendingPayment
            }
        },
        roundTotal() {
            if (typeof this.transaction === 'string') return 0;

            const payment = this.paymentMethods || [];
            const orders = this.transaction && this.transaction.orders;
            const last = orders && orders.length ? orders[orders.length - 1] : null;

            // Se prioriza LEY_REDONDEO que arma "transaction"
            if (last && last.type === 'LEY_REDONDEO') {
                const lastPrice = Number(last.price);
                return isNaN(lastPrice) ? 0 : lastPrice;
            }

            // Se calcula el redondeo en base a los .round (queda validar en que casos realmente se usa)
            const sumRound = this.SumCashRoundPayment(payment);
            const hasCashRound = payment.some(
                p => p.method === 'CASH' && p.round != null && p.round !== '' && Number(p.round) !== 0
            );

            if (hasCashRound) {
                return sumRound;
            }
            return 0;
        },
        tip() {
            if(!this.modalTips) return null;
            var tip = this.modalTips.amount.toString();
            var total = this.modalTips.subtotal.total;
            let methodPayment = this.modalTips.method;
            if(this.modalTips.subtotal.index == 'EACH_METHOD') 
            {
                let amount = parseInt(tip.toUpperCase().replace('-', '').replace('X', '').replace('%', ''));
                if(isNaN(amount)) return null;
            }
            if(tip.indexOf('%') > -1 || tip.toUpperCase().indexOf('X') > -1)
            {
                tip = parseFloat(tip.toUpperCase().replace('%', '').replace('X', ''));
                //tip = (this.total.totalMoney - this.discounts.totalDiscount) * (tip / 100);
                tip = total * (tip / 100);
                console.log(methodPayment);
                if(methodPayment == 'CASH') return tip <= 0? null : Util.RoundPesos(tip);
                return tip > 0 ? tip : null;
            }
            else if(tip.indexOf('-') > -1)
            {
                tip = parseInt(tip.replace('-', ''));
                //tip = tip - (this.total.totalMoney - this.discounts.totalDiscount);
                tip = tip - total;
                console.log(methodPayment);
                if(methodPayment == 'CASH') return tip <= 0? null : Util.RoundPesos(tip);
                return tip > 0 ? tip : null;
            }
            else if(!isNaN(tip))
            {
                console.log(methodPayment);
                if(methodPayment == 'CASH') return tip <= 0? null : Util.RoundPesos(tip);
                return parseInt(tip);
            }
            return null;
        },
        totalMoney() {
            return this.total.totalMoney - this.discounts.totalDiscount + this.roundTotal;
        },
        totalTips() {
            var total = 0;
            this.tips.forEach(tip => {
                //TODO: esto no deberia estar en una computada!!
                if(tip.amount && tip.index == null) {
                    this.RecalculateTip(tip);
                }
                total += tip.total;
            });
            return total;
        },
        minDate(){
            if(!this.orderedItems) return;

            let maxAnticipationTime = 0;
            let tmpDateStart = null;
            let dateStart = null;
            let anticipation = false;
            let countHaveAnticipation = 0;

            if(Object.values(this.orderedItems).length){
                for (let key in this.orderedItems) {
                    if (this.orderedItems.hasOwnProperty(key)) {
                        const item = this.orderedItems[key];

                        if(item.anticipation){
                            anticipation = true;
                            countHaveAnticipation++;
                        }

                        if (item.anticipation_time > maxAnticipationTime) maxAnticipationTime = item.anticipation_time;
                    }
                }

                const currentTime = Date.now();
                const tmpDateStartTimestamp = currentTime + (maxAnticipationTime * 60 * 60 * 1000);
                tmpDateStart = new Date(tmpDateStartTimestamp);
                dateStart = Math.floor(new Date(tmpDateStart) / 60000) * 60;
            }

            return {
                'anticipation': anticipation,
                'dateStart' : dateStart,
                'maxAnticipationTime' : anticipation? maxAnticipationTime : null,
                'dateStartParse' : anticipation && dateStart? this.Util.Date(dateStart, 'DD/MM/YYYY HH:mm') : null
            };
        },
        canEditTips() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.edit_tips);
        },
        canEditOld() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.edit_previous_items);
        },
        canAddDiscount() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.apply_discount);
        },
        canAddCoupon() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.apply_coupon);
        },
        canEditItemPricePOS() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.can_edit_item_price_pos);
        },
        missingPaymentMethods() {
            let ret = {};
            if(!this.fromTransaction) return ret;
            this.fromTransaction.payment.forEach(method => {
                if(method.method !== 'NO_SELECT') ret[method.method] = true;
            });
            return ret;
        },
        totalModalChangePriceItem(){
            if(!this.modalChangePriceItem) return;
            return Object.values(this.modalChangePriceItem.items).reduce((acc, item) => acc + (item.quantity * item.price), 0);
        }
    },
    watch: {
        customerAccount: function(n, o) {
            this.$emit('OnCustomerChanged', n);
        },
        modalEditPhone: function(n,o){
            if(n){
                this.$set(this.customer, 'newPhone',"")
            }else{
                this.$delete(this.customer, 'newPhone')
            }
        },
        schedule: function(n, o) {
            if(n && !o && !this.fromTransaction) 
            {
                this.$nextTick(() => {
                    if(this.$refs.dateSchedule) this.$refs.dateSchedule.OpenCalendar();
                });
            }
            this.$emit('OnScheduleDateChanged', n);
        }
    },
    beforeDestroy() {
        if(this.observer)
        {
            this.observer.disconnect();
            this.observer = null;   
        }
        this.parentScrollEl.removeEventListener('scroll', this.IsScrolledToBottom);
    }
}
</script>

<style lang="scss">
.cash-not-rounded.input-field input,
.cash-not-rounded.input-field .input {
    border-color: yellow !important;
}
.order-item {
    width: 100%;
    display: flex;
    align-items: flex-start; 
}
.order-item:last-child 
{

    border-bottom: none;
}

.order-item > div:first-child {
    width: 40px;
    font-weight: 600;
    flex-shrink: 0;
    /*margin-right: 10px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #EEE;
    border-radius: 50%;
    */
}
.order-item > div:nth-child(2)
{
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
}
.order-item > div:nth-child(3) {
    margin-left: 5px;
    font-weight: 500;
}
.method-header {
    font-size: 12px;
    border-top: 1px solid #CCC;
    color: #CCC;
    margin: 5px 0px;
    padding: 5px 0px;
}
.method-header.first {
    margin-top: 0px;
    border-top: none;
    padding-top: 0px;
}
.bottom-actions {
    position: sticky;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    left: 0;
    right: 0;
    bottom: 0px;
    z-index: 2;
    display: block !important;
}
.txt-right input {
    text-align: right;
    padding-right: 10px;
}
.customer-search-box {
    max-height: 300px; 
    background-color: var(--white); 
    position: absolute; 
    top: 56px; 
    left: 0px; 
    right: 0px; 
    border-radius: 5px; 
    box-shadow: 0px 5px 5px 0px rgba(0,0,0,0.1); 
    padding: 10px;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
}
.customer-search-item {
    padding: 5px 0px;
    border-bottom: 1px solid whitesmoke;
    cursor: pointer;
}
.customer-search-item:hover {
    background-color: rgba(0,0,0,0.01);
}
.customer-search-item:last-child {
    border-bottom: none;
}

.tag-delivered::before {
    content: "\e106";
    font-family: 'influye-font';
    font-size: 14px;
    color: rgb(0, 151, 255);
}
.tag-prepared::before {
    content: "\e100";
    font-family: 'influye-font';
    font-size: 14px;
    color: rgb(255, 187, 0);
}
.tag-order-form {
    right: 3px;
    top: 3px;
    height: 100%;
    border-radius: 50%;
}

.btn-pya {

    padding-left: 12px;
    padding-right: 12px;

    &:hover{
        background-color: var(--color-pya) !important;
        color: var(--white) !important;
    }
    
    i {
        transform: scale(1.4);
    }
}

.diner-tag {
    color: rgba(0,0,70,.85);
    padding: 0px 4px;
    border-radius: 4px;
    margin-right: 3px;
}

.border-trace {
  position: relative;
}

.border-trace .trace {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

.border-trace .trace rect {
    fill: none;
    stroke: var(--purple);
    stroke-linecap: round;

    stroke-width: 5;
    //stroke-dasharray: 14 86;
    stroke-dasharray: 30 70;
    animation: traceMove 3s linear infinite;

    //filter: drop-shadow(0 0 6px var(--purple));
}
.dark {
    .border-trace .trace rect {
        stroke: var(--dark-purple);
    }   
}

@keyframes traceMove {
  from {
    stroke-dashoffset: 0;
  }
  to {
    stroke-dashoffset: -100;
  }
}
</style>